<template>
  <div>
      <!-- 功能导航 -->
      <div class="function-nav">
        <div class="nav-tabs">
          <span class="tab" :class="{active: activeTab==='实时告警'}" @click="switchTab('实时告警')">实时告警</span>
          <span class="tab" :class="{active: activeTab==='历史查询'}" @click="switchTab('历史查询')">历史查询</span>
          <span class="tab" :class="{active: activeTab==='点位管理'}" @click="switchTab('点位管理')">点位管理</span>
          <span class="tab" :class="{active: activeTab==='处理流程'}" @click="switchTab('处理流程')">处理流程</span>
          <span class="tab" :class="{active: activeTab==='设备维修'}" @click="switchTab('设备维修')">设备维修</span>
        </div>
        <div class="refresh-btn" @click="refreshCurrentTab">
          <img src="images/alram/e2a3cbe1ebfd6d188b1927e610af0e25.png" />
          <span>刷新</span>
        </div>
      </div>
      <!-- tab内容区 -->
      <div v-if="activeTab==='实时告警'">
        <!-- 实时告警内容区 -->
        <div>
          <!-- 搜索筛选区域 -->
          <div class="search-section search-section-new">
            <form class="search-form-2x2">
              <div class="form-fields">
                <div class="form-item">
                  <label>所属厂区：</label>
                  <select class="form-input" v-model="alarmQuery.park">
                    <option value="">全部</option>
                    <option value="泰山路厂区">泰山路厂区</option>
                    <option value="梅江道厂区">梅江道厂区</option>
                  </select>
                </div>
                              <div class="form-item">
                <label>安装位置：</label>
                <select class="form-input" v-model="alarmQuery.location">
                  <option value="">全部</option>
                  <option value="低压工作区">低压工作区</option>
                  <option value="高压工作区">高压工作区</option>
                </select>
              </div>
                <!-- <div class="form-item">
                  <label>设备名称或编号：</label>
                  <input class="form-input" v-model="alarmQuery.deviceNameOrNumber" placeholder="设备名称或编号" />
                </div> -->
                                  <!-- <div class="form-item">
                    <label>开始日期：</label>
                    <input class="form-input" type="datetime-local" v-model="alarmQuery.startDate" placeholder="1970-01-01T00:00:00Z" />
                  </div>
                  <div class="form-item">
                    <label>结束日期：</label>
                    <input class="form-input" type="datetime-local" v-model="alarmQuery.startDate" placeholder="1970-01-01T00:00:00Z" />
                  </div> -->
              </div>
              <div class="form-btns">
                <button type="button" class="search-btn-green" @click="searchAlarm">
                  查询
                </button>
                <button type="button" class="search-btn-green" @click="printAlarm">打印</button>
              </div>
            </form>
          </div>
          <!-- 数据展示区域 -->
          <div class="data-section">
            <div class="data-layout">
              <!-- 左侧图片展示区 -->
              <div class="image-preview">
                <div class="preview-header">
                  <span class="preview-title">实时抓拍</span>
                  <span class="preview-subtitle">ICR</span>
                </div>
                <div class="preview-content">
                  <img v-if="currentImage" :src="currentImage" class="preview-image" @error="handleImageError" />
                  <div v-else class="no-image">
                    <span>暂无图片</span>
                  </div>
                </div>
              </div>
              <!-- 右侧告警信息列表 -->
              <div class="alarm-list">
                <h3 class="list-title">实时收图列表</h3>
                <div class="table-container">
                  <table class="data-table">
                    <thead>
                      <tr>
                        <th>违规类型</th>
                        <th>设备编号</th>
                        <th>位置</th>
                        <th>违规时间</th>
                        <th>所属厂区</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in pagedAlarmList" 
                          :key="index" 
                          @click="selectAlarm(item)"
                          :class="{ 'active': selectedAlarm === item }">
                        <td>{{ item.violationType || 'AI识别违规' }}</td>
                        <td>{{ item.deviceNumber || '未知设备ID' }}</td>
                        <td>{{ item.location || '未知位置' }}</td>
                        <td>{{ item.violationTime || '未知时间' }}</td>
                        <td style="color: #000; font-size: 12px;">{{ item.factory_area}}</td>
                      </tr>
                      <tr v-if="pagedAlarmList.length === 0">
                        <td colspan="6" style="text-align:center;color:#bbb;">暂无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- 实时告警分页 -->
                <div class="pagination">
                  <button class="page-btn" :disabled="alarmPage===1" @click="changeAlarmPage(1)">«</button>
                  <button class="page-btn" :disabled="alarmPage===1" @click="changeAlarmPage(alarmPage-1)">‹</button>
                  <span v-for="p in displayAlarmPages" :key="p">
                    <button class="page-btn" :class="{active:alarmPage===p}" @click="changeAlarmPage(p)">{{p}}</button>
                  </span>
                  <button class="page-btn" :disabled="alarmPage===alarmTotalPages" @click="changeAlarmPage(alarmPage+1)">›</button>
                  <button class="page-btn" :disabled="alarmPage===alarmTotalPages" @click="changeAlarmPage(alarmTotalPages)">»</button>
                  <div class="page-jump">
                    <input type="text" v-model="alarmPageInput" style="width:50px;" />
                    <button class="jump-btn" @click="jumpAlarmPage">跳转</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab==='历史查询'">
        <!-- 历史查询筛选区域 -->
        <div class="search-section search-section-new">
          <form class="search-form-2x2">
            <div class="form-fields">
              <div class="form-item">
                <label>所属厂区：</label>
                <select class="form-input" v-model="historyQuery.factory_area">
                  <option value="">全部</option>
                  <option value="泰山路厂区">泰山路厂区</option>
                  <option value="梅江道厂区">梅江道厂区</option>
                </select>
              </div>
              <div class="form-item">
                <label>安装位置：</label>
                <select class="form-input" v-model="historyQuery.location">
                  <option value="">全部</option>
                  <option value="低压工作区">低压工作区</option>
                  <option value="高压工作区">高压工作区</option>
                </select>
              </div>
              <div class="form-item">
                <label>设备编号：</label>
                <input class="form-input" v-model="historyQuery.deviceNumber" placeholder="请输入设备编号" />
              </div>
              <div class="form-item">
                <label>开始日期：</label>
                <input class="form-input" type="date" v-model="historyQuery.startDate" placeholder="选择开始日期" />
              </div>
              <div class="form-item">
                <label>结束日期：</label>
                <input class="form-input" type="date" v-model="historyQuery.endDate" placeholder="选择结束日期" />
              </div>
            </div>
            <div class="form-btns">
              <button type="button" class="search-btn-green" @click="searchHistory">查询</button>
              <button type="button" class="search-btn-green" @click="printHistory">打印</button>
            </div>
          </form>
        </div>
        <!-- 历史查询表格 -->
        <div class="data-section">
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>违规类型</th>
                  <th>设备编号</th>
                  <th>位置</th>
                  <th>违规时间</th>
                  <th>所属厂区</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in pagedHistoryList" :key="index">
                  <td>{{ (historyPage-1)*historyPageSize + index + 1 }}</td>
                  <td>{{ item.violationType || 'AI识别违规' }}</td>
                  <td>{{ item.deviceNumber || '未知设备ID' }}</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.violationTime }}</td>
                  <td>{{ item.factory_area}}</td>
                  <td>
                    <div class="table-action-bts">
                      <button class="search-btn-green" style="padding:4px 8px;" @click="showHistoryView(item)">
                        详情
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="pagedHistoryList.length === 0">
                  <td colspan="6" style="text-align:center;color:#bbb;">暂无数据</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <div class="pagination">
            <button class="page-btn" :disabled="historyPage===1" @click="changeHistoryPage(1)">«</button>
            <button class="page-btn" :disabled="historyPage===1" @click="changeHistoryPage(historyPage-1)">‹</button>
            <span v-for="p in displayHistoryPages" :key="p">
              <button class="page-btn" :class="{active:historyPage===p}" @click="changeHistoryPage(p)">{{p}}</button>
            </span>
            <button class="page-btn" :disabled="historyPage===historyTotalPages" @click="changeHistoryPage(historyPage+1)">›</button>
            <button class="page-btn" :disabled="historyPage===historyTotalPages" @click="changeHistoryPage(historyTotalPages)">»</button>
            <div class="page-jump">
              <input type="text" v-model="historyPageInput" style="width:50px;" />
              <button class="jump-btn" @click="jumpHistoryPage">跳转</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab==='点位管理'">
        <!-- 点位管理筛选区域 -->
        <div class="search-section search-section-new">
          <form class="search-form-2x2">
            <div class="form-fields">
              <div class="form-item">
                <label>设备编号：</label>
                <input class="form-input" v-model="pointQuery.deviceNumber" placeholder="设备编号" />
              </div>
              <!-- <div class="form-item">
                <label>设备名称：</label>
                <input class="form-input" v-model="pointQuery.deviceName" placeholder="设备名称" />
              </div> -->
              <!-- <div class="form-item">
                <label>设备类型：</label>
                <input class="form-input" v-model="pointQuery.deviceType" placeholder="设备类型" />
              </div> -->
              <div class="form-item">
                <label>点位：</label>
                <input class="form-input" v-model="pointQuery.location" placeholder="点位" />
              </div>
            </div>
            <div class="form-btns">
              <button type="button" class="search-btn-green" @click="searchPoint">搜索</button>
              <button type="button" class="search-btn-green" @click="printPoint">打印</button>
            </div>
          </form>
        </div>
        <!-- 新增按钮 -->
        <div style="margin: 0 0 16px 8px;">
          <button class="search-btn-green" style="background:#4caf50;" @click="pointAddMode=true">
            <span style="font-size:18px;font-weight:bold;">＋</span> 新增表具
          </button>
        </div>
        <!-- 点位管理表格 -->
        <div class="data-section">
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>设备编号</th>
                  <th>设备名称</th>
                  <th>设备类型</th>
                  <th>状态</th>
                  <th>点位</th>
                  <th>生产厂家</th>
                  <th>厂区</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in pagedPointList" :key="item.id">
                  <td>{{ (pointPage-1)*pointPageSize + idx + 1 }}</td>
                  <td>{{ item.deviceNumber }}</td>
                  <td>{{ item.deviceName }}</td>
                  <td>{{ item.deviceType }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.manufacturer }}</td>
                  <td>{{ item.factory_area }}</td>
                  <td style="display:flex;gap:8px;">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showPointView(item)">详情</button>
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showPointEdit(item)">编辑</button>
                  </td>
                </tr>
                <tr v-if="pagedPointList.length === 0">
                  <td colspan="9" style="text-align:center;color:#bbb;">暂无数据</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <div class="pagination">
            <button class="page-btn" :disabled="pointPage===1" @click="changePointPage(1)">«</button>
            <button class="page-btn" :disabled="pointPage===1" @click="changePointPage(pointPage-1)">‹</button>
            <span v-for="p in pointTotalPages" :key="p">
              <button class="page-btn" :class="{active:pointPage===p}" @click="changePointPage(p)">{{p}}</button>
            </span>
            <button class="page-btn" :disabled="pointPage===pointTotalPages" @click="changePointPage(pointPage+1)">›</button>
            <button class="page-btn" :disabled="pointPage===pointTotalPages" @click="changePointPage(pointTotalPages)">»</button>
            <div class="page-jump">
              <input type="text" v-model="pointPageInput" style="width:50px;" />
              <button class="jump-btn" @click="jumpPointPage">跳转</button>
            </div>
          </div>
        </div>
        <!-- 新增表具弹窗 -->
        <div v-if="pointAddMode" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
          <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
              <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">新增设备点位</span>
              <button @click="closePointAdd" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
            </div>
            <div style="display:flex;flex-direction:column;gap:18px;">
              <div>设备编号：<input class="form-input" v-model="pointAddItem.deviceNumber" style="width:400px;" /></div>
              <div>设备名称：<input class="form-input" v-model="pointAddItem.deviceName" style="width:400px;" /></div>
              <div>设备类型：<input class="form-input" v-model="pointAddItem.deviceType" style="width:400px;" placeholder="请输入设备类型" /></div>
              <div>设备状态：<input class="form-input" v-model="pointAddItem.deviceStatus" style="width:400px;" placeholder="请输入设备状态" /></div>
              <div>安装位置：<input class="form-input" v-model="pointAddItem.location" style="width:400px;" /></div>
              <div>详细位置：<input class="form-input" v-model="pointAddItem.detailLocation" style="width:400px;" /></div>
              <div>所属厂区：<input class="form-input" v-model="pointAddItem.factory_area" style="width:400px;" placeholder="请输入所属厂区" /></div>
              <div>生产厂家：<input class="form-input" v-model="pointAddItem.manufacturer" style="width:400px;" /></div>
              <div>安装说明：<textarea class="form-input" v-model="pointAddItem.installDesc" style="width:400px;height:60px;"></textarea></div>
              <div style="display:flex;align-items:center;">安装图片：
                <div style="margin-left:12px;">
                  <label style="cursor:pointer;">
                    <input type="file" accept="image/*" style="display:none;" @change="onPointAddImageChange" />
                    <div v-if="!pointAddItem.imageUrl" style="width:80px;height:80px;border:1px solid #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:36px;color:#888;background:#fafbfc;">
                      <i class="el-icon-camera"></i>+
                    </div>
                    <img v-else :src="processImageUrl(pointAddItem.imageUrl)" style="width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #ddd;" />
                  </label>
                </div>
              </div>
              <div>申报人：<input class="form-input" v-model="pointAddItem.reporter" style="width:400px;" /></div>
              <div>申请时间：<input class="form-input" type="datetime-local" v-model="pointAddItem.applyTime" style="width:400px;" /></div>
            </div>
            <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
              <button class="search-btn-green" @click="savePointAdd" style="min-width:80px;">保存</button>
              <button class="search-btn-green" @click="closePointAdd" style="background:#eee;color:#333;min-width:80px;">取消</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab==='处理流程'">
        <!-- 处理流程筛选区域 -->
        <div class="search-section search-section-new">
          <form class="search-form-2x2">
            <div class="form-fields">
              <div class="form-item">
                <label>所属厂区：</label>
                <select class="form-input" v-model="processQuery.park">
                  <option value="">全部</option>
                  <option value="泰山路厂区">泰山路厂区</option>
                  <option value="梅江道厂区">梅江道厂区</option>
                </select>
              </div>
              <div class="form-item">
                <label>设备名称：</label>
                <input class="form-input" v-model="processQuery.deviceName" placeholder="设备名称" />
              </div>
              <!-- <div class="form-item">
                <label>识别类型：</label>
                <select class="form-input" v-model="processQuery.recognitionType">
                  <option value="">全部</option>
                  <option value="绝缘鞋识别">绝缘鞋识别</option>
                  <option value="绝缘胶鞋识别">绝缘胶鞋识别</option>
                </select>
              </div> -->
              <div class="form-item">
                <label>安装位置：</label>
                <select class="form-input" v-model="processQuery.location">
                  <option value="">全部</option>
                  <option value="高压工作区">高压工作区</option>
                  <option value="低压工作区">低压工作区</option>
                </select>
              </div>
              <div class="form-item">
                <label>开始日期：</label>
                <input class="form-input" type="date" v-model="processQuery.startDate" placeholder="选择开始日期" />
              </div>
              <div class="form-item">
                <label>结束日期：</label>
                <input class="form-input" type="date" v-model="processQuery.endDate" placeholder="选择结束日期" />
              </div>
            </div>
            <div class="form-btns">
              <button type="button" class="search-btn-green" @click="searchProcess">搜索</button>
              <button type="button" class="search-btn-green" @click="printProcess">打印</button>
            </div>
          </form>
        </div>
        <!-- 新增按钮 -->
        <!-- <div style="margin: 0 0 16px 8px;">
          <button class="search-btn-green" style="background:#4caf50;" @click="openProcessAdd">
            <span style="font-size:18px;font-weight:bold;">＋</span> 新增违规信息
          </button>
        </div> -->
        <!-- 处理流程表格 -->
        <div class="data-section">
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>违规编号</th>
                  <th>设备名称</th>
                  <th>所属厂区</th>
                  <th>安装位置</th>
                  <th>识别类型</th>
                  <th>违规人</th>
                  <th>违规时间</th>
                  <th>处理人</th>
                  <th>处理时间</th>
                  <th>处理状态</th>
                  <th style="min-width:120px;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in pagedProcessList" :key="item.id">
                  <td>{{ (processPage-1)*processPageSize + idx + 1 }}</td>
                  <td>{{ item.violationNumber }}</td>
                  <td>{{ item.deviceName }}</td>
                  <td>{{ item.violationCompany }}</td>
                  <td>{{ item.location }}</td>
                  <td>{{ item.recognitionType }}</td>
                  <td>{{ item.violationPerson }}</td>
                  <td>{{ formatTime(item.violationTime) }}</td>
                  <td>{{ item.handler }}</td>
                  <td>{{ formatTime(item.handleTime) }}</td>
                  <td>
                    <span v-if="item.processState==='未处理'" style="color:#fff;background:#e74c3c;padding:2px 8px;border-radius:4px;font-size:13px;">未处理</span>
                    <span v-else style="color:#fff;background:#4caf50;padding:2px 8px;border-radius:4px;font-size:13px;">已处理</span>
                  </td>
                  <td style="display:flex;gap:8px;white-space:nowrap;">
                    <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="showProcessView(item)">详情</button>
                    <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="showProcessEdit(item)">编辑</button>
                  </td>
                </tr>
                <tr v-if="pagedProcessList.length === 0">
                  <td colspan="12" style="text-align:center;color:#bbb;">暂无数据</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <div class="pagination">
            <button class="page-btn" :disabled="processPage===1" @click="changeProcessPage(1)">«</button>
            <button class="page-btn" :disabled="processPage===1" @click="changeProcessPage(processPage-1)">‹</button>
            <span v-for="p in displayProcessPages" :key="p">
              <button class="page-btn" :class="{active:processPage===p}" @click="changeProcessPage(p)">{{p}}</button>
            </span>
            <button class="page-btn" :disabled="processPage===processTotalPages" @click="changeProcessPage(processPage+1)">›</button>
            <button class="page-btn" :disabled="processPage===processTotalPages" @click="changeProcessPage(processTotalPages)">»</button>
            <div class="page-jump">
              <input type="text" v-model="processPageInput" style="width:50px;" />
              <button class="jump-btn" @click="jumpProcessPage">跳转</button>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="activeTab==='设备维修'">
        <!-- 设备维修筛选区域 -->
        <div class="search-section search-section-new">
          <form class="search-form-2x2">
            <div class="form-fields">
              <div class="form-item">
                <label>设备名称：</label>
                <input class="form-input" v-model="repairQuery.facMessage" placeholder="设备名称或ID号" />
              </div>
              <div class="form-item">
                <label>解决状态：</label>
                <select class="form-input" v-model="repairQuery.resolutionState">
                  <option value="">全部</option>
                  <option value="未解决">未解决</option>
                  <option value="已解决">已解决</option>
                </select>
              </div>
              <div class="form-item">
                <label>开始日期：</label>
                <input class="form-input" type="date" v-model="repairQuery.startDate" placeholder="选择开始日期" />
              </div>
              <div class="form-item">
                <label>结束日期：</label>
                <input class="form-input" type="date" v-model="repairQuery.endDate" placeholder="选择结束日期" />
              </div>
            </div>
            <div class="form-btns">
              <button type="button" class="search-btn-green" @click="searchRepair">查询</button>
              <button type="button" class="search-btn-green" @click="printRepair">打印</button>
            </div>
          </form>
        </div>
        
        <!-- 新增按钮 -->
        <div style="margin: 0 0 16px 8px;">
          <button class="search-btn-green" style="background:#4caf50;" @click="openRepairAdd">
            <span style="font-size:18px;font-weight:bold;">＋</span> 新增维修信息
          </button>
        </div>
        
        <!-- 设备维修表格 -->
        <div class="data-section">
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th>序号</th>
                  <th>维修ID</th>
                  <th>设备名称</th>
                  <th>申报人</th>
                  <th>申报时间</th>
                  <!-- 新增故障图片列 -->
                  <th>故障图片</th>
                  <th>解决状态</th>
                  <!-- 新增解决图片列 -->
                  <th>解决图片</th>
                  <th>解决人</th>
                  <th>解决时间</th>
                  <th style="min-width:120px;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in pagedRepairList" :key="item.id">
                  <td>{{ (repairPage-1)*repairPageSize + idx + 1 }}</td>
                  <td>{{ item.maintenance_id }}</td>
                  <td>{{ item.fac_name }}</td>
                  <td>{{ item.applicant }}</td>
                  <td>{{ formatTime(item.applicant_date) }}</td>
                  <!-- 新增故障图片列 -->
                  <td>
                    <img v-if="item.faultImage" :src="item.faultImage" style="width:40px;height:30px;border-radius:4px;object-fit:cover;cursor:pointer;" @click="previewImage(item.faultImage)" />
                    <span v-else style="color:#999;font-size:12px;">无图片</span>
                  </td>
                  <td>
                    <span v-if="item.resolution_state==='未解决'" style="color:#fff;background:#e74c3c;padding:2px 8px;border-radius:4px;font-size:13px;">未解决</span>
                    <span v-else style="color:#fff;background:#4caf50;padding:2px 8px;border-radius:4px;font-size:13px;">已解决</span>
                  </td>
                  <!-- 新增解决图片列 -->
                  <td>
                    <img v-if="item.solveImage" :src="item.solveImage" style="width:40px;height:30px;border-radius:4px;object-fit:cover;cursor:pointer;" @click="previewImage(item.solveImage)" />
                    <span v-else style="color:#999;font-size:12px;">无图片</span>
                  </td>
                  <td>{{ item.resolution_people }}</td>
                  <td>{{ formatTime(item.resolution_date) }}</td>
                  <td style="display:flex;gap:8px;white-space:nowrap;">
                    <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="showRepairView(item)">详情</button>
                    <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="showRepairEdit(item)">编辑</button>
                  </td>
                </tr>
                <tr v-if="pagedRepairList.length === 0">
                  <td colspan="11" style="text-align:center;color:#bbb;">暂无数据</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 分页 -->
          <div class="pagination">
            <button class="page-btn" :disabled="repairPage===1" @click="changeRepairPage(1)">«</button>
            <button class="page-btn" :disabled="repairPage===1" @click="changeRepairPage(repairPage-1)">‹</button>
            <span v-for="p in displayRepairPages" :key="p">
              <button class="page-btn" :class="{active:repairPage===p}" @click="changeRepairPage(p)">{{p}}</button>
            </span>
            <button class="page-btn" :disabled="repairPage===repairTotalPages" @click="changeRepairPage(repairPage+1)">›</button>
            <button class="page-btn" :disabled="repairPage===repairTotalPages" @click="changeRepairPage(repairTotalPages)">»</button>
            <div class="page-jump">
              <input type="text" v-model="repairPageInput" style="width:50px;" />
              <button class="jump-btn" @click="jumpRepairPage">跳转</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 点位管理详情弹窗 -->
    <div v-if="pointDetailMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">设备详情</span>
          <button @click="closePointDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div>设备编号：<input class="form-input" :value="pointDetailItem.deviceNumber" style="width:400px;" readonly /></div>
          <div>设备名称：<input class="form-input" :value="pointDetailItem.deviceName" style="width:400px;" readonly /></div>
          <div>设备类型：<input class="form-input" :value="pointDetailItem.deviceType" style="width:400px;" readonly /></div>
          <div>状态：<input class="form-input" :value="pointDetailItem.status" style="width:400px;" readonly /></div>
          <div>点位：<input class="form-input" :value="pointDetailItem.location" style="width:400px;" readonly /></div>
          <div>详细位置：<input class="form-input" :value="pointDetailItem.detailLocation" style="width:400px;" readonly /></div>
          <div>所属厂区：<input class="form-input" :value="pointDetailItem.factory_area" style="width:400px;" readonly /></div>
          <div>生产厂家：<input class="form-input" :value="pointDetailItem.manufacturer" style="width:400px;" readonly /></div>
          <div>安装说明：<textarea class="form-input" :value="pointDetailItem.installInstruction" style="width:400px;height:60px;" readonly></textarea></div>
          <div>安装日期：<input class="form-input" :value="pointDetailItem.installDate" style="width:400px;" readonly /></div>
          <div>安装图片：
            <div style="margin-left:12px;display:inline-block;">
              <img v-if="pointDetailItem.installPhotoUrl" :src="processImageUrl(pointDetailItem.installPhotoUrl)" style="width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #ddd;cursor:pointer;" @click="previewImage(processImageUrl(pointDetailItem.installPhotoUrl))" />
              <div v-else style="width:80px;height:80px;border:1px solid #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:36px;color:#888;background:#fafbfc;">无</div>
            </div>
          </div>
          <div>申报人：<input class="form-input" :value="pointDetailItem.applicant" style="width:400px;" readonly /></div>
        </div>
      </div>
    </div>
    <!-- 点位管理编辑弹窗 -->
    <div v-if="pointDetailMode === 'edit'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">编辑设备</span>
          <button @click="closePointDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div>设备编号：<input class="form-input" :value="pointDetailItem.deviceNumber" style="width:400px;" readonly /></div>
          <div>设备名称：<input class="form-input" v-model="pointDetailItem.deviceName" style="width:400px;" /></div>
          <div>设备类型：<input class="form-input" v-model="pointDetailItem.deviceType" style="width:400px;" /></div>
          <div>状态：<input class="form-input" v-model="pointDetailItem.status" style="width:400px;" /></div>
          <div>点位：<input class="form-input" v-model="pointDetailItem.location" style="width:400px;" /></div>
          <div>生产厂家：<input class="form-input" v-model="pointDetailItem.manufacturer" style="width:400px;" /></div>
          <div>所属厂区：<input class="form-input" v-model="pointDetailItem.factory_area" style="width:400px;" /></div>
          <div>详细位置：<input class="form-input" v-model="pointDetailItem.detailLocation" style="width:400px;" /></div>
          <div>安装说明：<textarea class="form-input" v-model="pointDetailItem.installInstruction" style="width:400px;height:60px;"></textarea></div>
          <div>安装日期：<input class="form-input" type="datetime-local" v-model="pointDetailItem.installDate" style="width:400px;" /></div>
          <div>安装图片：
            <div style="margin-left:12px;display:inline-block;">
              <label style="cursor:pointer;">
                <input type="file" accept="image/*" style="display:none;" @change="onPointDetailImageChange" />
                <div v-if="!pointDetailItem.installPhotoUrl" style="width:80px;height:80px;border:1px solid #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:36px;color:#888;background:#fafbfc;">
                  <i class="el-icon-camera"></i>+
                </div>
                <img v-else :src="processImageUrl(pointDetailItem.installPhotoUrl)" style="width:80px;height:80px;border-radius:8px;object-fit:cover;border:1px solid #ddd;cursor:pointer;" @click="previewImage(processImageUrl(pointDetailItem.installPhotoUrl))" />
              </label>
            </div>
          </div>
          <div>申报人：<input class="form-input" v-model="pointDetailItem.applicant" style="width:400px;" /></div>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="savePointEdit" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closePointDetailModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>
    <!-- 处理流程详情弹窗 -->
    <div v-if="processDetailMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">处理流程详情</span>
          <button @click="closeProcessDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div>违规编号：<input class="form-input" :value="processDetailItem.violationNumber" style="width:400px;" readonly /></div>
          <div>设备名称：<input class="form-input" :value="processDetailItem.deviceName" style="width:400px;" readonly /></div>
          <div>所属厂区：<input class="form-input" :value="processDetailItem.violationCompany" style="width:400px;" readonly /></div>
          <div>安装位置：<input class="form-input" :value="processDetailItem.location" style="width:400px;" readonly /></div>
          <div>识别类型：<input class="form-input" :value="processDetailItem.recognitionType" style="width:400px;" readonly /></div>
          <div>违规人：<input class="form-input" :value="processDetailItem.violationPerson" style="width:400px;" readonly /></div>
          <div>违规时间：<input class="form-input" :value="processDetailItem.violationTime" style="width:400px;" readonly /></div>
          <div>处理人：<input class="form-input" :value="processDetailItem.handler" style="width:400px;" readonly /></div>
          <div>处理时间：<input class="form-input" :value="processDetailItem.handleTime" style="width:400px;" readonly /></div>
          <div>处理状态：<input class="form-input" :value="processDetailItem.processState" style="width:400px;" readonly /></div>
          <!-- <div>处理说明：<textarea class="form-input" :value="processDetailItem.process_instruction" style="width:400px;height:60px;" readonly placeholder="暂无处理说明"></textarea></div> -->
        </div>
      </div>
    </div>
    
    <!-- 处理流程编辑弹窗 -->
    <div v-if="processDetailMode === 'edit'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">编辑处理流程</span>
          <button @click="closeProcessDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div>违规人：<input class="form-input" v-model="processDetailItem.violationPerson" style="width:400px;" placeholder="请输入违规人姓名" /></div>
          <div>处理人：<input class="form-input" v-model="processDetailItem.handler" style="width:400px;" placeholder="请输入处理人姓名" /></div>
          <div>处理时间：<input class="form-input" type="datetime-local" v-model="processDetailItem.handleTime" style="width:400px;" /></div>
          <div>处理状态：<select class="form-input" v-model="processDetailItem.processState" style="width:400px;">
            <option value="未处理">未处理</option>           
            <option value="已解决">已解决</option>
          </select></div>
          <div>处理说明：<input class="form-input" v-model="processDetailItem.process_instruction" style="width:400px;" /></div>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveProcessEdit" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeProcessDetailModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>
  <!-- 新增历史详情弹窗 -->
  <div v-if="historyDetailMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
    <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
        <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">历史记录详情</span>
        <button @click="closeHistoryDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
      </div>
      <div style="display:flex;flex-direction:column;gap:18px;">
        <div>设备名称：<input class="form-input" :value="historyDetailItem.deviceName" style="width:400px;" readonly /></div>
        <div>安装位置：<input class="form-input" :value="historyDetailItem.location" style="width:400px;" readonly /></div>
      
        <div>违规时间：<input class="form-input" :value="historyDetailItem.violationTime" style="width:400px;" readonly /></div>
        <!-- 图片显示区域 -->
        <div v-if="historyDetailItem && (historyDetailItem.imageUrl || historyDetailItem.imageData)">
          <span style="display:inline-block;width:80px;text-align:left;vertical-align:top;margin-top:8px;">图片：</span>
          <div style="display:inline-block;width:400px;vertical-align:top;">
            <img v-if="historyDetailItem.imageUrl" 
                 :src="historyDetailItem.imageUrl" 
                 alt="图片" 
                 style="max-width:320px;max-height:200px;margin-bottom:0;border-radius:8px;box-shadow:0 2px 8px #0001;cursor:pointer;" 
                 @click="previewImage(historyDetailItem.imageUrl)" />
            <div v-else style="display:flex;align-items:center;gap:8px;">
              <span style="color:#666;">正在加载图片...</span>
              <button class="search-btn-green" style="padding:4px 8px;" @click="loadHistoryImage(historyDetailItem)">
                重新加载
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 大图预览弹窗 -->
  <div v-if="showImagePreview" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0008;z-index:2000;display:flex;align-items:center;justify-content:center;" @click="closeImagePreview">
    <div style="max-width:90vw;max-height:90vh;position:relative;" @click.stop>
      <img :src="previewImageUrl" style="max-width:100%;max-height:100%;border-radius:8px;box-shadow:0 4px 20px #0003;" />
      <button @click="closeImagePreview" style="position:absolute;top:-40px;right:0;background:#fff;border:none;border-radius:50%;width:32px;height:32px;font-size:20px;cursor:pointer;box-shadow:0 2px 8px #0002;">×</button>
    </div>
  </div>

  <!-- 新增违规信息弹窗 -->
  <div v-if="processAddMode" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
    <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
      <!-- <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
        <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">新增违规信息</span>
        <button @click="closeProcessAdd" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
      </div> -->
      <div style="display:flex;flex-direction:column;gap:18px;">
        <div>违规编号：<input class="form-input" v-model="processAddItem.violateId" style="width:400px;" placeholder="违规编号将自动生成" readonly /></div>
        <div>设备名称：<input class="form-input" v-model="processAddItem.deviceName" style="width:400px;" placeholder="请输入设备名称" /></div>
        <div>设备类型：<input class="form-input" v-model="processAddItem.deviceType" style="width:400px;" placeholder="请输入设备类型" /></div>

        <div>所属厂区：<select class="form-input" v-model="processAddItem.factory_area" style="width:400px;">
          <option value="">请选择厂区</option>
          <option value="泰山路厂区">泰山路厂区</option>
          <option value="梅江道厂区">梅江道厂区</option>
        </select></div>
        <div>违规人：<input class="form-input" v-model="processAddItem.violator" style="width:400px;" placeholder="请输入违规人姓名" /></div>
        <div>违规时间：<input class="form-input" type="datetime-local" v-model="processAddItem.violateDate" style="width:400px;" /></div>
        <div>违规说明：<textarea class="form-input" v-model="processAddItem.violateInstruction" style="width:400px;height:60px;" placeholder="请输入违规说明"></textarea></div>
        <div>处理人：<input class="form-input" v-model="processAddItem.processPerson" style="width:400px;" placeholder="请输入处理人姓名" /></div>
        <div>处理时间：<input class="form-input" type="datetime-local" v-model="processAddItem.processDate" style="width:400px;" /></div>
        <div>处理状态：<select class="form-input" v-model="processAddItem.processState" style="width:400px;">
          <option value="未处理">未处理</option>
          <option value="已处理">已处理</option>
        </select></div>
        <div>处理说明：<textarea class="form-input" v-model="processAddItem.processInstruction" style="width:400px;height:60px;" placeholder="请输入处理说明"></textarea></div>
      </div>
      <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
        <button class="search-btn-green" @click="saveProcessAdd" style="min-width:80px;">保存</button>
        <button class="search-btn-green" @click="closeProcessAdd" style="background:#eee;color:#333;min-width:80px;">取消</button>
      </div>
    </div>
  </div>
  
  <!-- 设备维修新增弹窗 -->
  <div v-if="repairAddMode" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
    <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
        <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">新增维修信息</span>
        <button @click="closeRepairAdd" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
      </div>
      <div style="display:flex;flex-direction:column;gap:18px;">
        <div>维修ID：<input class="form-input" :value="generateMaintenanceId()" style="width:400px;" readonly /></div>
        
        <!-- 设备编号下拉框 -->
        <div>设备编号：
          <select class="form-input" v-model="repairAddItem.fac_id" @change="onDeviceChange" style="width:400px;">
            <option value="">请选择设备编号</option>
            <option v-for="option in pointOptions" :key="option.fac_id" :value="option.fac_id">
              {{ option.fac_id }}
            </option>
          </select>
        </div>
        
        <!-- 设备名称（自动填充） -->
        <div>设备名称：<input class="form-input" v-model="repairAddItem.fac_name" style="width:400px;" readonly /></div>
        
        <!-- 设备点位（自动填充） -->
        <div>设备点位：<input class="form-input" v-model="repairAddItem.fac_point" style="width:400px;" readonly /></div>
        
        <div>申报人：<input class="form-input" v-model="repairAddItem.applicant" style="width:400px;" placeholder="请输入申报人" /></div>
        <div>申报时间：<input class="form-input" type="datetime-local" v-model="repairAddItem.applicant_date" style="width:400px;" /></div>
        <div>故障说明：<textarea class="form-input" v-model="repairAddItem.fault_description" style="width:400px;height:60px;" placeholder="请输入故障说明"></textarea></div>
        <div>解决状态：<select class="form-input" v-model="repairAddItem.resolution_state" style="width:400px;">
          <option value="未解决">未解决</option>
          <option value="已解决">已解决</option>
        </select></div>
        <div>解决说明：<textarea class="form-input" v-model="repairAddItem.resolution_description" style="width:400px;height:60px;" placeholder="请输入解决说明"></textarea></div>
        <div>解决人：<input class="form-input" v-model="repairAddItem.resolution_people" style="width:400px;" placeholder="请输入解决人" /></div>
        <div>解决时间：<input class="form-input" type="date" v-model="repairAddItem.resolution_date" style="width:400px;" /></div>
        <!-- 新增图片上传区域 -->
        <div style="display:flex;flex-direction:column;gap:12px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:censter;font-size:14px;">故障图片：</span>
            <div style="flex:1;">
              <label style="cursor:pointer;display:block;">
                <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairAddImageChange(e, 'fault')" />
                <div v-if="!repairAddItem.faultImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                  <div style="font-size:20px;margin-bottom:4px;">+</div>
                  <div>点击上传</div>
                </div>
                <img v-else :src="repairAddItem.faultImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairAddItem.faultImage)" />
              </label>
            </div>
          </div>
          
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:center;font-size:14px;">解决图片：</span>
            <div style="flex:1;">
              <label style="cursor:pointer;display:block;">
                <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairAddImageChange(e, 'solve')" />
                <div v-if="!repairAddItem.solveImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                  <div style="font-size:20px;margin-bottom:4px;">+</div>
                  <div>点击上传</div>
                </div>
                <img v-else :src="repairAddItem.solveImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairAddItem.solveImage)" />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
        <button class="search-btn-green" @click="saveRepairAdd" style="min-width:80px;">保存</button>
        <button class="search-btn-green" @click="closeRepairAdd" style="background:#eee;color:#333;min-width:80px;">取消</button>
      </div>
    </div>
  </div>
  
  <!-- 设备维修详情弹窗 -->
  <div v-if="repairDetailMode === 'view'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
    <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
        <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">维修详情</span>
        <button @click="closeRepairDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
      </div>
      <div style="display:flex;flex-direction:column;gap:18px;">
        <div>维修ID：<input class="form-input" :value="repairDetailItem.maintenance_id" style="width:400px;" readonly /></div>
        <div>设备编号：<input class="form-input" :value="repairDetailItem.fac_id" style="width:400px;" readonly /></div>
        <div>设备名称：<input class="form-input" :value="repairDetailItem.fac_name" style="width:400px;" readonly /></div>
        <div>设备点位：<input class="form-input" :value="repairDetailItem.fac_point" style="width:400px;" readonly /></div>
        <div>申报人：<input class="form-input" :value="repairDetailItem.applicant" style="width:400px;" readonly /></div>
        <div>申报时间：<input class="form-input" :value="formatTime(repairDetailItem.applicant_date)" style="width:400px;" readonly /></div>
        <div>故障说明：<textarea class="form-input" :value="repairDetailItem.fault_description" style="width:400px;height:60px;" readonly></textarea></div>
        <div>解决状态：<input class="form-input" :value="repairDetailItem.resolution_state" style="width:400px;" readonly /></div>
        <div>解决说明：<textarea class="form-input" :value="repairDetailItem.resolution_description" style="width:400px;height:60px;" readonly></textarea></div>
        <div>解决人：<input class="form-input" :value="repairDetailItem.resolution_people" style="width:400px;" readonly /></div>
        <div>解决时间：<input class="form-input" :value="formatTime(repairDetailItem.resolution_date)" style="width:400px;" readonly /></div>
        <!-- 新增图片显示区域 -->
        <div style="display:flex;flex-direction:column;gap:12px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:center;font-size:14px;">故障图片：</span>
            <div style="flex:1;">
              <img v-if="repairDetailItem.faultImage" :src="repairDetailItem.faultImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairDetailItem.faultImage)" />
              <div v-else style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:12px;color:#999;background:#fafbfc;">无图片</div>
            </div>
          </div>
          
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:center;font-size:14px;">解决图片：</span>
            <div style="flex:1;">
              <img v-if="repairDetailItem.solveImage" :src="repairDetailItem.solveImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairDetailItem.solveImage)" />
              <div v-else style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:12px;color:#999;background:#fafbfc;">无图片</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- 设备维修编辑弹窗 -->
  <div v-if="repairDetailMode === 'edit'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
    <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
        <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">编辑维修信息</span>
        <button @click="closeRepairDetailModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
      </div>
      <div style="display:flex;flex-direction:column;gap:18px;">
        <div>维修ID：<input class="form-input" :value="repairDetailItem.maintenance_id" style="width:400px;" readonly /></div>
        <div>设备编号：<input class="form-input" v-model="repairDetailItem.fac_id" style="width:400px;" placeholder="请输入设备编号" readonly /></div>
        <div>设备名称：<input class="form-input" v-model="repairDetailItem.fac_name" style="width:400px;" placeholder="请输入设备名称" readonly /></div>
        <div>设备点位：<input class="form-input" v-model="repairDetailItem.fac_point" style="width:400px;" placeholder="请输入设备点位" readonly /></div>
        <div>申报人：<input class="form-input" v-model="repairDetailItem.applicant" style="width:400px;" placeholder="请输入申报人" /></div>
        <div>申报时间：<input class="form-input" type="datetime-local" v-model="repairDetailItem.applicant_date" style="width:400px;" /></div>
        <div>故障说明：<textarea class="form-input" v-model="repairDetailItem.fault_description" style="width:400px;height:60px;" placeholder="请输入故障说明"></textarea></div>
        <div>解决状态：<select class="form-input" v-model="repairDetailItem.resolution_state" style="width:400px;">
          <option value="未解决">未解决</option>
          <option value="已解决">已解决</option>
        </select></div>
        <div>解决说明：<textarea class="form-input" v-model="repairDetailItem.resolution_description" style="width:400px;height:60px;" placeholder="请输入解决说明"></textarea></div>
        <div>解决人：<input class="form-input" v-model="repairDetailItem.resolution_people" style="width:400px;" placeholder="请输入解决人" /></div>
        <div>解决时间：<input class="form-input" type="datetime-local" v-model="repairDetailItem.resolution_date" style="width:400px;" /></div>
        <!-- 新增图片上传区域 -->
        <div style="display:flex;flex-direction:column;gap:12px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:censter;font-size:14px;">故障图片：</span>
            <div style="flex:1;">
              <label style="cursor:pointer;display:block;">
                <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairDetailImageChange(e, 'fault')" />
                <div v-if="!repairDetailItem.faultImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                  <div style="font-size:20px;margin-bottom:4px;">+</div>
                  <div>点击上传</div>
                </div>
                <img v-else :src="repairDetailItem.faultImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairDetailItem.faultImage)" />
              </label>
            </div>
          </div>
          
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:center;font-size:14px;">解决图片：</span>
            <div style="flex:1;">
              <label style="cursor:pointer;display:block;">
                <input type="file" accept="image/*" style="display:none;" @change="(e) => onRepairDetailImageChange(e, 'solve')" />
                <div v-if="!repairDetailItem.solveImage" style="width:120px;height:80px;border:2px dashed #ddd;border-radius:8px;display:flex;flex-direction:column;align-items:center;justify-content:center;font-size:12px;color:#888;background:#fafbfc;transition:all 0.3s;">
                  <div style="font-size:20px;margin-bottom:4px;">+</div>
                  <div>点击上传</div>
                </div>
                <img v-else :src="repairDetailItem.solveImage" style="width:120px;height:80px;border-radius:8px;object-fit:cover;border:2px solid #ddd;cursor:pointer;" @click="previewImage(repairDetailItem.solveImage)" />
              </label>
            </div>
          </div>
        </div>
      </div>
      <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
        <button class="search-btn-green" @click="saveRepairEdit" style="min-width:80px;">保存</button>
        <button class="search-btn-green" @click="closeRepairDetailModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
      </div>
    </div>
  </div>

  </div>
</template>


<script>
import { createPointMessage, queryPointMessage, queryViolations, createViolation, createMaintenance, queryMaintenance } from '@/api/substation';

export default {
  name: 'SubstationAlarm',
  data() {
    return {
      currentImage: '', // 当前显示的图片
      selectedAlarm: null, // 当前选中的告警信息
      alarmList: [

      ],
      alarmQuery: {
        park: '',
        location: '',
        deviceNameOrNumber: '',
        startDate: '',
        endDate: ''
      },
      alarmPage: 1,
      alarmPageSize: 10,
      alarmPageInput: '1',
      activeTab: '实时告警',
      // 历史查询相关
      historyQuery: {
        factory_area: '',
        location: '',
        deviceNumber: '',
        startDate: '',
        endDate: ''
      },
      historyList: [],
      historyPage: 1,
      historyPageSize: 10,
      historyPageInput: '1',
      // historyTotalPagesState: 1, // 添加总页数状态
      // 点位管理相关
      pointQuery: {
        deviceNumber: '',
        park: '',
        location: '',
        startDate: '',
        endDate: ''
      },
      pointList: [

      ],
      pointPage: 1,
      pointPageSize: 10,
      pointPageInput: '1',
      // 处理流程相关
      processQuery: {
        park: '',
        deviceName: '',
        recognitionType: '',
        location: '',
        startDate: '',
        endDate: ''
      },
      processList: [
        {
          id: 1,
          violationNumber: '25486155401',
          deviceName: '200万像素摄像头',
          location: '变电站低压室左上方',
          recognitionType: '绝缘鞋',
          violationPerson: '赵海化',
          violationCompany: '一厂',
          violationTime: '2025-04-24 14:00:01',
          handler: '赵海化',
          handleTime: '2025-04-24 14:00:01',
          process_instruction: ''
        }
      ],
      processPage: 1,
      processPageSize: 10,
      processPageInput: '1',
      // 点位管理新增弹窗相关
      pointAddMode: false,
      pointAddItem: {
        deviceNumber: '',
        deviceName: '',
        deviceType: '摄像头',
        deviceStatus: '在线',
        location: '',
        detailLocation: '',
        installDesc: '',
        factory_area: '泰山路厂区',
        manufacturer: '海康威视',
        imageUrl: '',
        imageFile: null,
        reporter: '',
        applyTime: ''
      },
      // 详情/编辑弹窗相关
      pointDetailMode: '', // 'view' | 'edit'
      pointDetailItem: null,
      processDetailMode: '', // 'view' | 'edit'
      processDetailItem: null,
      // 新增历史详情/编辑弹窗相关
      historyDetailMode: '', // 'view' | 'edit'
      historyDetailItem: null,
      // 图片预览相关
      showImagePreview: false,
      previewImageUrl: '',
      // 处理流程新增弹窗相关
      processAddMode: false,
      processAddItem: {
        violateId: '',
        deviceName: '',
        deviceType: '',
        recognitionType: '',
        factory_area: '',
        violator: '',
        violateDate: '',
        violateInstruction: '',
        processPerson: '',
        processDate: '',
        processState: '未处理',
        processInstruction: ''
      },
      // 设备维修相关
      repairQuery: {
        facMessage: '',
        resolutionState: '',
        startDate: '',
        endDate: ''
      },
      repairList: [],
      repairPage: 1,
      repairPageSize: 10,
      repairPageInput: '1',
      // 设备维修弹窗相关
      repairAddMode: false,
      repairDetailMode: '', // 'view' | 'edit'
      repairDetailItem: null,
      repairAddItem: {
        maintenance_id: '',
        fac_id: '',
        fac_name: '',
        fac_point: '',
        applicant: '',
        applicant_date: '',
        fault_description: '',
        resolution_state: '未解决',
        resolution_description: '',
        resolution_people: '',
        resolution_date: '',
        // 新增图片字段
        faultImage: null,
        solveImage: null
      },
      // 历史查询分页状态
      historyTotalPagesState: 1, // 添加总页数状态
      
      // 点位管理分页状态  
      pointTotalPagesState: 1,
      
      // 处理流程分页状态
      processTotalPagesState: 1,
      
      // 设备维修分页状态
      repairTotalPagesState: 1,
      
      // 实时告警独立的分页状态
      alarmTotalPagesState: 1, // 添加实时告警总页数状态
      pointOptions: [], // 添加点位选项列表
    }
  },
  computed: {
    pagedAlarmList() {
      // 实时告警使用独立的数据源和分页逻辑
      console.log('=== 实时告警分页计算 ===');
      console.log('this.alarmList:', this.alarmList);
      console.log('this.alarmList.length:', this.alarmList ? this.alarmList.length : 'undefined');
      console.log('this.alarmPage:', this.alarmPage);
      console.log('this.alarmPageSize:', this.alarmPageSize);
      
      // 安全检查：确保数据列表存在
      if (!this.alarmList || this.alarmList.length === 0) {
        console.log('实时告警数据列表为空，返回空数组');
        return [];
      }
      
      // 实时告警使用API分页，直接返回整个列表
      // 因为数据已经通过API分页获取了
      return this.alarmList;
    },
    
    alarmTotalPages() {
      // 实时告警使用独立的总页数状态
      console.log('=== 计算实时告警总页数 ===');
      console.log('this.alarmTotalPagesState:', this.alarmTotalPagesState);
      
      // 使用实时告警独立的总页数状态
      if (this.alarmTotalPagesState && this.alarmTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.alarmTotalPagesState);
        return this.alarmTotalPagesState;
      }
      
      // 如果没有API分页信息，则根据数据长度计算
      const calculatedPages = Math.max(1, Math.ceil((this.alarmList ? this.alarmList.length : 0) / this.alarmPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      return calculatedPages;
    },
    pagedHistoryList() {
      // 如果使用API分页，直接返回整个列表
      if (this.historyTotalPagesState && this.historyTotalPagesState > 0) {
        return this.historyList;
      }
      
      // 否则使用前端分页
      const start = (this.historyPage-1)*this.historyPageSize;
      const end = start + this.historyPageSize;
      return this.historyList.slice(start, end);
    },
    historyTotalPages() {
      // 如果API返回了总页数信息，使用API的数据；否则根据当前列表长度计算
      if (this.historyTotalPagesState && this.historyTotalPagesState > 0) {
        return this.historyTotalPagesState;
      }
      
      const calculatedPages = Math.max(1, Math.ceil((this.historyList ? this.historyList.length : 0) / this.historyPageSize));
      return calculatedPages;
    },
    pagedPointList() {
      console.log('=== 点位管理分页计算 ===');
      console.log('this.pointList:', this.pointList);
      console.log('this.pointList.length:', this.pointList ? this.pointList.length : 'undefined');
      console.log('this.pointPage:', this.pointPage);
      console.log('this.pointPageSize:', this.pointPageSize);
      
      // 安全检查：确保数据列表存在
      if (!this.pointList || this.pointList.length === 0) {
        console.log('点位管理数据列表为空，返回空数组');
        return [];
      }
      
      // 如果使用API分页，直接返回整个列表
      if (this.pointTotalPagesState && this.pointTotalPagesState > 0) {
        console.log('使用API分页，直接返回整个列表');
        return this.pointList;
      }
      
      // 否则使用前端分页
      const start = (this.pointPage-1)*this.pointPageSize;
      const end = start + this.pointPageSize;
      const result = this.pointList.slice(start, end);
      
      console.log('前端分页结果:', result);
      console.log('分页范围:', start, '到', end);
      
      return result;
    },
    pointTotalPages() {
      console.log('=== 计算点位管理总页数 ===');
      console.log('this.pointTotalPagesState:', this.pointTotalPagesState);
      
      // 如果API返回了总页数信息，使用API的数据
      if (this.pointTotalPagesState && this.pointTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.pointTotalPagesState);
        return this.pointTotalPagesState;
      }
      
      // 否则根据当前列表长度计算
      const calculatedPages = Math.max(1, Math.ceil((this.pointList ? this.pointList.length : 0) / this.pointPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      return calculatedPages;
    },
    pagedProcessList() {
      console.log('=== 处理流程分页计算 ===');
      console.log('this.processList:', this.processList);
      console.log('this.processList.length:', this.processList ? this.processList.length : 'undefined');
      console.log('this.processPage:', this.processPage);
      console.log('this.processPageSize:', this.processPageSize);
      
      // 安全检查：确保数据列表存在
      if (!this.processList || this.processList.length === 0) {
        console.log('处理流程数据列表为空，返回空数组');
        return [];
      }
      
      // 如果使用API分页，直接返回整个列表
      if (this.processTotalPagesState && this.processTotalPagesState > 0) {
        console.log('使用API分页，直接返回整个列表');
        return this.processList;
      }
      
      // 否则使用前端分页
      const start = (this.processPage-1)*this.processPageSize;
      const end = start + this.processPageSize;
      const result = this.processList.slice(start, end);
      
      console.log('前端分页结果:', result);
      console.log('分页范围:', start, '到', end);
      
      return result;
    },
    processTotalPages() {
      console.log('=== 计算处理流程总页数 ===');
      console.log('this.processTotalPagesState:', this.processTotalPagesState);
      
      // 如果API返回了总页数信息，使用API的数据
      if (this.processTotalPagesState && this.processTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.processTotalPagesState);
        return this.processTotalPagesState;
      }
      
      // 否则根据当前列表长度计算
      const calculatedPages = Math.max(1, Math.ceil((this.processList ? this.processList.length : 0) / this.processPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      return calculatedPages;
    },
    pagedRepairList() {
      console.log('=== 设备维修分页计算 ===');
      console.log('this.repairList:', this.repairList);
      console.log('this.repairList.length:', this.repairList ? this.repairList.length : 'undefined');
      console.log('this.repairPage:', this.repairPage);
      console.log('this.repairPageSize:', this.repairPageSize);
      
      // 安全检查：确保数据列表存在
      if (!this.repairList || this.repairList.length === 0) {
        console.log('设备维修数据列表为空，返回空数组');
        return [];
      }
      
      // 如果使用API分页，直接返回整个列表
      if (this.repairTotalPagesState && this.repairTotalPagesState > 0) {
        console.log('使用API分页，直接返回整个列表');
        return this.repairList;
      }
      
      // 否则使用前端分页
      const start = (this.repairPage-1)*this.repairPageSize;
      const end = start + this.repairPageSize;
      const result = this.repairList.slice(start, end);
      
      console.log('前端分页结果:', result);
      console.log('分页范围:', start, '到', end);
      
      return result;
    },
    repairTotalPages() {
      console.log('=== 计算设备维修总页数 ===');
      console.log('this.repairTotalPagesState:', this.repairTotalPagesState);
      
      // 如果API返回了总页数信息，使用API的数据
      if (this.repairTotalPagesState && this.repairTotalPagesState > 0) {
        console.log('使用API返回的总页数:', this.repairTotalPagesState);
        return this.repairTotalPagesState;
      }
      
      // 否则根据当前列表长度计算
      const calculatedPages = Math.max(1, Math.ceil((this.repairList ? this.repairList.length : 0) / this.repairPageSize));
      console.log('根据列表长度计算的总页数:', calculatedPages);
      return calculatedPages;
    },
    // 新增：生成显示的页码范围，最多显示10页
    displayAlarmPages() {
      const total = this.alarmTotalPages;
      const current = this.alarmPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayHistoryPages() {
      const total = this.historyTotalPages;
      const current = this.historyPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayProcessPages() {
      const total = this.processTotalPages;
      const current = this.processPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayRepairPages() {
      const total = this.repairTotalPages;
      const current = this.repairPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    // 新增：转换图片URL格式的方法
    convertImageUrl(url) {
      if (!url) return url;
      
      // 将 http://47.93.132.27:6011/pic?F5A4FFEA6B52A0433AF7A45DD80286FB 格式
      // 转换为 https://gdykpt.cn/pic/F5A4FFEA6B52A0433AF7A45DD80286FB 格式
      if (url.includes('http://47.93.132.27:6011/pic?')) {
        const imageId = url.split('?')[1];
        return `https://gdykpt.cn/pic/${imageId}`;
      }
      
      return url;
    },

    selectAlarm(alarm) {
      this.selectedAlarm = alarm;
      
      // 如果有图片URL，直接显示
      if (alarm.imageUrl) {
        this.currentImage = alarm.imageUrl;
      } else if (alarm.imageData) {
        // 如果没有图片URL但有图片数据，尝试获取图片
        this.currentImage = ''; // 先清空，避免显示旧图片
        
        // 显示加载状态
        this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
        
        // 新的数据格式中，图片URL直接存储在violation_photo字段中
        if (alarm.imageData.violation_photo) {
          // 转换图片URL格式并直接使用violation_photo作为图片URL
          alarm.imageUrl = this.convertImageUrl(alarm.imageData.violation_photo);
          this.currentImage = alarm.imageUrl;
          console.log('实时告警图片加载成功，使用violation_photo:', alarm.imageUrl);
        } else {
          // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
          this.getCaptureImage(alarm.imageData, alarm.originalCaptureTime || alarm.updateTime)
            .then(imageUrl => {
              if (imageUrl) {
                alarm.imageUrl = imageUrl;
                this.currentImage = imageUrl;
              } else {
                // 如果获取失败，显示默认图片
                this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
              }
            })
            .catch(error => {
              console.error('获取告警图片失败:', error);
              // 显示默认图片或错误提示
              this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
            });
        }
      } else {
        // 既没有图片URL也没有图片数据，显示默认图片
        this.currentImage = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPuaaguaXoOaXoOaEjzwvdGV4dD48L3N2Zz4=';
      }
    },
    

    async searchAlarm() {
      // 设置实时告警的默认时间范围：当天零点到当天23:59:59
      const now = new Date();
      const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
      const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      
      // 格式化时间，只取日期部分（YYYY-MM-DD格式）
      this.alarmQuery.startDate = todayStart.toISOString().slice(0, 10);
      this.alarmQuery.endDate = todayEnd.toISOString().slice(0, 10);
      
      // 构建实时告警查询参数
      const params = {
        plate_number: '', // 不再使用车牌号查询
        install_area: this.alarmQuery.location || '',
        fac_id: this.alarmQuery.deviceNameOrNumber || '', // 使用设备名称或编号查询fac_id字段
        factory_area: this.alarmQuery.park || '', // 使用所属厂区查询factory_area字段
        start_date: this.alarmQuery.startDate ? this.formatDateForAPI(this.alarmQuery.startDate) : '',
        end_date: this.alarmQuery.endDate ? this.formatDateForAPI(this.alarmQuery.endDate) : '',
        page: this.alarmPage,
        per_page: this.alarmPageSize
      };
      
      console.log('=== 实时告警查询请求参数 ===');
      console.log('请求参数:', params);
      console.log('========================');
      
      try {
        const response = await queryViolations(params);
        
   
        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          console.log('API返回数据:', response.data);
          console.log('数据数组长度:', response.data.data.length);
          
          // 转换API返回的数据格式为前端需要的格式
          this.alarmList = response.data.data.map((item, index) => {
            console.log(`处理第${index + 1}条实时告警数据:`, item);
            
            // 解码Unicode编码的中文字符
            const decodeUnicode = (str) => {
              if (!str) return str;
              return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
              });
            };
            
            const processedItem = {
              id: item.violate_id || index + 1,
              deviceNumber: decodeUnicode(item.fac_id) || '未知设备ID',
              deviceName: decodeUnicode(item.fac_name) || '雷视一体机',
              location: decodeUnicode(item.install_area) || '未知位置',
              vehicleType: '货车', // 默认车辆类型
              plateNumber: decodeUnicode(item.plate_number) || '无车牌',
              violationTime: item.violate_date ? this.formatTime(item.violate_date) : '',
              originalCaptureTime: item.violate_date || '', // 保存原始时间用于图片获取
              speed: item.speed ? `${item.speed}km/h` : '',
              factory_area: decodeUnicode(item.factory_area) || '未知厂区',
              // 保存图片相关数据以备后用
              imageData: {
                violation_photo: this.convertImageUrl(item.violation_photo || ''),
                fac_id: item.fac_id || '',
                violate_date: item.violate_date || ''
              }
            };
            
            console.log(`处理后的实时告警第${index + 1}项:`, processedItem);
            return processedItem;
          });
          
          console.log('最终实时告警列表:', this.alarmList);
          console.log('列表长度:', this.alarmList.length);
          
          // 设置实时告警总页数
          if (response.data.total_pages) {
            this.alarmTotalPagesState = response.data.total_pages;
            console.log('设置实时告警总页数:', this.alarmTotalPagesState);
          }
          
          // 检查页码有效性，如果当前页超出总页数，重置为第一页
          if (this.alarmTotalPagesState > 0 && this.alarmPage > this.alarmTotalPagesState) {
            console.log('当前页码超出总页数，重置为第1页');
            this.alarmPage = 1;
          }
          
          // 强制触发Vue的响应式更新
          this.$forceUpdate();
          
          // 数据加载完成后，自动选中第一条记录
          if (this.alarmList.length > 0) {
            this.selectAlarm(this.alarmList[0]);
          }
          
        } else {
          console.error('查询实时告警失败: 响应数据格式不正确');
          console.error('response.data:', response.data);
          this.alarmList = [];
          this.alarmTotalPagesState = 1;
        }
        
      } catch (error) {
        console.error('实时告警查询失败:', error);
        this.alarmList = [];
        this.alarmTotalPagesState = 1;
      }
    },
    
    changeAlarmPage(page) {
      console.log('=== 实时告警分页切换 ===');
      console.log('当前页:', this.alarmPage);
      console.log('目标页:', page);
      console.log('总页数:', this.alarmTotalPages);
      
      if (page < 1) {
        console.warn('页码不能小于1，忽略分页切换');
        return;
      }
      
      this.alarmPage = page;
      console.log('设置新页码:', this.alarmPage);
      
      // 重新查询数据
      this.searchAlarm();
    },
    jumpAlarmPage() {
      let p = parseInt(this.alarmPageInput);
      if (!isNaN(p) && p >= 1 && p <= this.alarmTotalPages) {
        this.alarmPage = p;
        this.alarmPageInput = p.toString();
        // 实时告警需要重新查询数据
        this.searchAlarm();
      } else {
        alert('请输入有效的页码');
      }
    },
    async searchHistory() {
      // 记录查询开始时间
      const startTime = new Date();
      console.log('=== 开始历史查询 ===');
      console.log('查询开始时间:', startTime.toISOString());
      console.log('查询参数:', this.historyQuery);
      console.log('当前页码:', this.historyPage);
      console.log('每页数量:', this.historyPageSize);
      
      try {
        // 构建查询参数，使用queryViolations接口
        const params = {
          plate_number: '', // 不再使用车牌号查询
          install_area: this.historyQuery.location || '',
          fac_id: this.historyQuery.deviceNumber || '', // 使用设备编号查询fac_id字段
          factory_area: this.historyQuery.factory_area || '', // 使用所属厂区查询factory_area字段
          start_date: this.historyQuery.startDate ? this.formatDateForAPI(this.historyQuery.startDate) : '',
          end_date: this.historyQuery.endDate ? this.formatDateForAPI(this.historyQuery.endDate) : '',
          page: this.historyPage,
          per_page: this.historyPageSize
        };
        
        console.log('=== 历史查询请求参数 ===');
        console.log('请求参数:', params);
        console.log('========================');
        
        const response = await queryViolations(params);
        
        console.log('=== 历史查询接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('当前页:', response.data.current_page);
        console.log('总页数:', response.data.total_pages);
        console.log('总数据量:', response.data.total);
        console.log('========================');
        
        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          console.log('API返回数据:', response.data);
          console.log('数据数组长度:', response.data.data.length);
          
          // 转换API返回的数据格式为前端需要的格式
          this.historyList = response.data.data.map((item, index) => {
            console.log(`处理第${index + 1}条原始数据:`, item);
            
            // 解码Unicode编码的中文字符
            const decodeUnicode = (str) => {
              if (!str) return str;
              return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
                return String.fromCharCode(parseInt(hex, 16));
              });
            };
            
            const processedItem = {
              id: item.violate_id || index + 1,
              deviceNumber: decodeUnicode(item.fac_id) || '未知设备ID',
              deviceName: decodeUnicode(item.fac_name) || '雷视一体机',
              location: decodeUnicode(item.install_area) || '未知位置',
              vehicleType: '货车', // 默认车辆类型
              plateNumber: decodeUnicode(item.plate_number) || '无车牌',
              violationTime: item.violate_date ? this.formatTime(item.violate_date) : '',
              originalCaptureTime: item.violate_date || '', // 保存原始时间用于图片获取
              speed: item.speed ? `${item.speed}km/h` : '',
              factory_area: decodeUnicode(item.factory_area) || '未知厂区',
              // 保存图片相关数据以备后用
              imageData: {
                violation_photo: this.convertImageUrl(item.violation_photo || ''),
                fac_id: item.fac_id || '',
                violate_date: item.violate_date || ''
              }
            };
            
            console.log(`处理后的历史记录第${index + 1}项:`, processedItem);
            return processedItem;
          });
          
          console.log('最终历史查询列表:', this.historyList);
          console.log('列表长度:', this.historyList.length);
          
          // 设置总页数
          if (response.data.total_pages) {
            this.historyTotalPagesState = response.data.total_pages;
            console.log('设置历史查询总页数:', this.historyTotalPagesState);
          }
          
          // 检查页码有效性，如果当前页超出总页数，重置为第一页
          if (this.historyTotalPagesState > 0 && this.historyPage > this.historyTotalPagesState) {
            console.log('当前页码超出总页数，重置为第1页');
            this.historyPage = 1;
            this.alarmPage = 1; // 同时重置实时告警页码
          }
          
          // 强制触发Vue的响应式更新
          this.$forceUpdate();
          
          // 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            console.log('=== nextTick后的状态检查 ===');
            console.log('this.historyList:', this.historyList);
            console.log('this.pagedHistoryList:', this.pagedHistoryList);
            console.log('this.pagedAlarmList:', this.pagedAlarmList);
            console.log('========================');
          });
          
          return Promise.resolve(); // 返回Promise以便链式调用
        } else {
          console.error('查询历史记录失败: 响应数据格式不正确');
          console.error('response.data:', response.data);
          this.historyList = [];
          this.historyTotalPagesState = 1;
          return Promise.resolve();
        }
        

        
      } catch (error) {
        const endTime = new Date();
        const duration = endTime.getTime() - startTime.getTime();
        console.log('=== 历史查询失败 ===');
        console.log('查询失败时间:', endTime.toISOString());
        console.log('查询耗时:', duration + 'ms');
        console.error('历史查询失败:', error);
        
        // 如果API调用失败，使用空列表
        this.historyList = [];
        this.historyTotalPagesState = 1;
        return Promise.resolve();
      }
    },
// 修改实时告警的打印功能
async printAlarm() {
  try {
    console.log('=== 开始打印实时告警数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      plate_number: '', // 不再使用车牌号查询
      install_area: this.alarmQuery.location || '',
      fac_id: this.alarmQuery.deviceNameOrNumber || '', // 使用设备名称或编号查询fac_id字段
      factory_area: this.alarmQuery.park || '', // 使用所属厂区查询factory_area字段
      start_date: this.alarmQuery.startDate ? this.formatDateForAPI(this.alarmQuery.startDate) : '',
      end_date: this.alarmQuery.endDate ? this.formatDateForAPI(this.alarmQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryViolations(params);
    
    console.log('打印API响应:', response);
    
    let allAlarmData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allAlarmData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        // 解码Unicode编码的中文字符
        const decodeUnicode = (str) => {
          if (!str) return str;
          return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
            return String.fromCharCode(parseInt(hex, 16));
          });
        };
        
        const processedItem = {
          id: item.violate_id || index + 1,
          deviceNumber: decodeUnicode(item.fac_id) || '未知设备ID',
          deviceName: decodeUnicode(item.fac_name) || '雷视一体机',
          location: decodeUnicode(item.install_area) || '未知位置',
          violationTime: item.violate_date ? this.formatTime(item.violate_date) : '',
          factory_area: decodeUnicode(item.factory_area) || '未知厂区'
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allAlarmData);
      console.log('打印数据列表长度:', allAlarmData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allAlarmData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">实时告警列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allAlarmData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">位置</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属厂区</th>
            </tr>
          </thead>
          <tbody>
            ${allAlarmData.map((item) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">AI识别违规</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationTime}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.factory_area}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 实时告警打印完成 ===');
    
  } catch (error) {
    console.error('打印实时告警数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改历史查询的打印功能
async printHistory() {
  try {
    console.log('=== 开始打印历史查询数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      plate_number: '', // 不再使用车牌号查询
      install_area: this.historyQuery.location || '',
      fac_id: this.historyQuery.deviceNumber || '', // 使用设备编号查询fac_id字段
      factory_area: this.historyQuery.factory_area || '', // 使用所属厂区查询factory_area字段
      start_date: this.historyQuery.startDate ? this.formatDateForAPI(this.historyQuery.startDate) : '',
      end_date: this.historyQuery.endDate ? this.formatDateForAPI(this.historyQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryViolations(params);
    
    console.log('打印API响应:', response);
    
    let allHistoryData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allHistoryData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        // 解码Unicode编码的中文字符
        const decodeUnicode = (str) => {
          if (!str) return str;
          return str.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
            return String.fromCharCode(parseInt(hex, 16));
          });
        };
        
        const processedItem = {
          id: item.violate_id || index + 1,
          deviceNumber: decodeUnicode(item.fac_id) || '未知设备ID',
          deviceName: decodeUnicode(item.fac_name) || '雷视一体机',
          location: decodeUnicode(item.install_area) || '未知位置',
          violationTime: item.violate_date ? this.formatTime(item.violate_date) : '',
          factory_area: decodeUnicode(item.factory_area) || '未知厂区'
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allHistoryData);
      console.log('打印数据列表长度:', allHistoryData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allHistoryData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">历史查询列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allHistoryData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">位置</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属厂区</th>
            </tr>
          </thead>
          <tbody>
            ${allHistoryData.map((item) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">AI识别违规</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationTime}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.factory_area}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 历史查询打印完成 ===');
    
  } catch (error) {
    console.error('打印历史查询数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改点位管理的打印功能
async printPoint() {
  try {
    console.log('=== 开始打印点位管理数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      fac_id: this.pointQuery.deviceNumber,
      factory_area: this.pointQuery.park,
      fac_point: this.pointQuery.location,
      start_date: this.pointQuery.startDate ? this.formatDateForAPI(this.pointQuery.startDate) : '',
      end_date: this.pointQuery.endDate ? this.formatDateForAPI(this.pointQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryPointMessage(params);
    
    console.log('打印API响应:', response);
    
    let allPointData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allPointData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        const processedItem = {
          id: item.fac_id,
          deviceNumber: item.fac_id,
          deviceName: item.fac_name || '未命名设备',
          deviceType: item.fac_model || '未知类型',
          status: item.fac_state || '未知状态',
          location: item.fac_point || '未知位置',
          manufacturer: item.manufacturer || '未知厂家',
          factory_area: item.factory_area || '未知区域'
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allPointData);
      console.log('打印数据列表长度:', allPointData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allPointData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">点位管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allPointData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">状态</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">点位</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">生产厂家</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">厂区</th>
            </tr>
          </thead>
          <tbody>
            ${allPointData.map((item, idx) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceType}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.status}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.manufacturer}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.factory_area}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 点位管理打印完成 ===');
    
  } catch (error) {
    console.error('打印点位管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改处理流程的打印功能
async printProcess() {
  try {
    console.log('=== 开始打印处理流程数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      factory_area: this.processQuery.park,
      fac_message: this.processQuery.deviceName,
      identify_type: this.processQuery.recognitionType,
      install_area: this.processQuery.location,
      start_date: this.processQuery.startDate ? this.formatDateForAPI(this.processQuery.startDate) : '',
      end_date: this.processQuery.endDate ? this.formatDateForAPI(this.processQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryViolations(params);
    
    console.log('打印API响应:', response);
    
    let allProcessData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allProcessData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        const processedItem = {
          id: item.violate_id,
          violationNumber: item.violate_id,
          deviceName: item.fac_name || item.fac_id || '未知设备',
          location: item.install_area || '未知位置',
          recognitionType: item.identify_type || '未知类型',
          violationPerson: item.violator || '未知',
          violationCompany: item.factory_area || '未知公司',
          violationTime: item.violate_date || '未知时间',
          handler: item.process_person || '未处理',
          handleTime: item.process_date ,
          processState: item.process_state || '未处理'
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allProcessData);
      console.log('打印数据列表长度:', allProcessData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allProcessData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">处理流程列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allProcessData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属厂区</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">识别类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">违规时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">处理人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">处理时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">处理状态</th>
            </tr>
          </thead>
          <tbody>
            ${allProcessData.map((item, idx) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationNumber}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationCompany}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.location}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.recognitionType}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.violationPerson}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${this.formatTime(item.violationTime)}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.handler}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${this.formatTime(item.handleTime)}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.processState}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 处理流程打印完成 ===');
    
  } catch (error) {
    console.error('打印处理流程数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改设备维修的打印功能
async printRepair() {
  try {
    console.log('=== 开始打印设备维修数据 ===');
    
    // 构建查询参数，设置perpage为500获取所有数据
    const params = {
      fac_message: this.repairQuery.facMessage,
      resolution_state: this.repairQuery.resolutionState,
      start_date: this.repairQuery.startDate ? this.formatDateForAPI(this.repairQuery.startDate) : '',
      end_date: this.repairQuery.endDate ? this.formatDateForAPI(this.repairQuery.endDate) : '',
      page: 1, // 从第一页开始
      per_page: 500 // 设置每页500条数据
    };
    
    console.log('打印查询参数:', params);
    
    // 调用API获取所有数据
    const response = await queryMaintenance(params);
    
    console.log('打印API响应:', response);
    
    let allRepairData = [];
    
    // 检查响应数据结构
    if (response.data && Array.isArray(response.data.data)) {
      console.log('API返回数据:', response.data);
      console.log('数据数组长度:', response.data.data.length);
      
      // 转换API返回的数据格式为前端需要的格式
      allRepairData = response.data.data.map((item, index) => {
        console.log(`处理第${index + 1}条打印数据:`, item);
        
        const processedItem = {
          id: item.maintenance_id || item.id || '未知ID',
          maintenance_id: item.maintenance_id || item.id || '未知ID',
          fac_id: item.fac_id || '未知设备',
          fac_name: item.fac_name || '未知设备名称',
          fac_point: item.fac_point || '未知位置',
          applicant: item.applicant || '未知申报人',
          applicant_date: item.applicant_date || '',
          fault_description: item.fault_description || '无故障描述',
          resolution_state: item.resolution_state || '未解决',
          resolution_description: item.resolution_description || '无解决说明',
          resolution_people: item.resolution_people || '未知解决人',
          resolution_date: item.resolution_date || '',
          // 添加图片URL处理
          faultImage: this.processImageUrl(item.fault_photo_url) || null,
          solveImage: this.processImageUrl(item.resolution_photo_url) || null
        };
        
        console.log(`处理后的打印数据第${index + 1}项:`, processedItem);
        return processedItem;
      });
      
      console.log('最终打印数据列表:', allRepairData);
      console.log('打印数据列表长度:', allRepairData.length);
    } else {
      console.error('打印数据获取失败: 响应数据格式不正确');
      console.error('response.data:', response.data);
      allRepairData = [];
    }
    
    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">设备维修列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allRepairData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">维修ID</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">申报人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">申报时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决状态</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决人</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">解决时间</th>
            </tr>
          </thead>
          <tbody>
            ${allRepairData.map((item, idx) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${idx + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.maintenance_id}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.fac_name}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.applicant}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${this.formatTime(item.applicant_date)}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.resolution_state}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.resolution_people}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${this.formatTime(item.resolution_date)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 设备维修打印完成 ===');
    
  } catch (error) {
    console.error('打印设备维修数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},
    jumpHistoryPage() {
      let p = parseInt(this.historyPageInput);
      if (!isNaN(p) && p >= 1) {
        this.historyPage = p;
        this.searchHistory();
      } else {
        alert('请输入大于等于1的页码');
      }
    },
    searchPoint() {
      // 调用后端接口查询点位信息
      this.fetchPointData();
      this.pointPage = 1;
    },
    async fetchPointData() {
      try {
        // 构建查询参数
        const params = {};
        if (this.pointQuery.deviceNumber) params.fac_id = this.pointQuery.deviceNumber;
        if (this.pointQuery.park) params.factory_area = this.pointQuery.park;
        if (this.pointQuery.location) params.fac_point = this.pointQuery.location;
        if (this.pointQuery.startDate) params.start_date = this.pointQuery.startDate;
        if (this.pointQuery.endDate) params.end_date = this.pointQuery.endDate;
        params.page = this.pointPage;
        params.per_page = this.pointPageSize;

        console.log('=== 点位管理查询请求参数 ===');
        console.log('请求参数:', params);
        console.log('当前页码:', this.pointPage);
        console.log('每页数量:', this.pointPageSize);
        console.log('========================');

        const response = await queryPointMessage(params);
        const result = response.data;
        
        console.log('=== 点位管理接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('当前页:', response.data.current_page);
        console.log('总页数:', response.data.total_pages);
        console.log('总数据量:', response.data.total);
        console.log('========================');
        
        if (result.status === 'success' || result.data) {
          // 转换数据格式以匹配前端显示
          this.pointList = result.data.map(item => ({
            id: item.fac_id,
            deviceNumber: item.fac_id,
            deviceName: item.fac_name || '未命名设备',
            deviceType: item.fac_model || '未知类型',
            status: item.fac_state || '未知状态',
            location: item.fac_point || '未知位置',
            manufacturer: item.manufacturer || '未知厂家',
            factory_area: item.factory_area || '未知区域',
            detailLocation: item.detail_location,
            installInstruction: item.install_instruction,
            installDate: item.install_date,
            installPhotoUrl: item.install_photo_url,
            applicant: item.applicant
          }));
          
          console.log('=== 点位管理数据转换完成 ===');
          console.log('转换后的数据:', this.pointList);
          console.log('数据长度:', this.pointList.length);
          console.log('========================');
          
          // 更新分页信息
          this.pointTotalPages = result.total_pages || 1;
          this.pointPage = parseInt(result.current_page) || 1;
          
          // 设置总页数状态
          this.pointTotalPagesState = result.total_pages || 1;
          
          // 强制触发Vue的响应式更新
          this.$forceUpdate();
          
          // 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            console.log('=== nextTick后的点位管理状态检查 ===');
            console.log('this.pointList:', this.pointList);
            console.log('this.pagedPointList:', this.pagedPointList);
            console.log('this.pointPage:', this.pointPage);
            console.log('this.pointTotalPages:', this.pointTotalPages);
            console.log('========================');
          });
          
        } else {
          console.error('查询点位信息失败:', result);
          this.pointList = [];
        }
      } catch (error) {
        console.error('获取点位数据失败:', error);
        this.pointList = [];
      }
    },

    jumpPointPage() {
      let p = parseInt(this.pointPageInput);
      console.log('=== 点位管理跳转页面 ===');
      console.log('输入页码:', p);
      console.log('总页数:', this.pointTotalPages);
      
      if (!isNaN(p) && p >= 1 && p <= this.pointTotalPages) {
        this.pointPage = p;
        this.pointPageInput = p.toString();
        console.log('跳转到页码:', this.pointPage);
        this.searchPoint();
      } else {
        alert('请输入有效的页码');
      }
    },
    async searchProcess() {
      try {
        // 构建查询参数
        const params = {};
        if (this.processQuery.park) params.factory_area = this.processQuery.park;
        if (this.processQuery.deviceName) params.fac_message = this.processQuery.deviceName;
        if (this.processQuery.recognitionType) params.identify_type = this.processQuery.recognitionType;
        if (this.processQuery.location) params.install_area = this.processQuery.location;
        if (this.processQuery.startDate) params.start_date = this.processQuery.startDate;
        if (this.processQuery.endDate) params.end_date = this.processQuery.endDate;
        params.page = this.processPage;
        params.per_page = this.processPageSize;

        console.log('=== 处理流程查询请求参数 ===');
        console.log('请求参数:', params);
        console.log('当前页码:', this.processPage);
        console.log('每页数量:', this.processPageSize);
        console.log('========================');

        const response = await queryViolations(params);
        const result = response.data;
        
        console.log('=== 处理流程接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('当前页:', response.data.current_page);
        console.log('总页数:', response.data.total_pages);
        console.log('总数据量:', response.data.total);
        console.log('========================');
        
        if (result.data) {
          // 转换数据格式以匹配前端显示
          this.processList = result.data.map(item => ({
            id: item.violate_id,
            violationNumber: item.violate_id,
            deviceName: item.fac_name || item.fac_id || '未知设备',
            location: item.install_area || '未知位置',
            recognitionType: item.identify_type || '未知类型',
            violationPerson: item.violator || '未知',
            violationCompany: item.factory_area || '未知公司',
            violationTime: item.violate_date || '未知时间',
            handler: item.process_person || '未处理',
            handleTime: item.process_date ,
            processState: item.process_state || '未处理',
            process_instruction: item.process_instruction,
            // 保存原始数据用于详情展示
            originalData: item
          }));
          
          console.log('=== 处理流程数据转换完成 ===');
          console.log('转换后的数据:', this.processList);
          console.log('数据长度:', this.processList.length);
          console.log('========================');
          
          // 更新分页信息
          this.processTotalPages = result.total_pages || 1;
          this.processPage = parseInt(result.current_page) || 1;
          
          // 添加这行：设置总页数状态
          if (result.total_pages) {
            this.processTotalPagesState = result.total_pages;
            console.log('设置处理流程总页数:', this.processTotalPagesState);
          }
          
          // 强制触发Vue的响应式更新
          this.$forceUpdate();
          
          // 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            console.log('=== nextTick后的处理流程状态检查 ===');
            console.log('this.processList:', this.processList);
            console.log('this.pagedProcessList:', this.pagedProcessList);
            console.log('this.processPage:', this.processPage);
            console.log('this.processTotalPages:', this.processTotalPages);
            console.log('========================');
          });
          
        } else {
          console.error('查询违规信息失败:', result);
          this.processList = [];
        }
      } catch (error) {
        console.error('获取违规数据失败:', error);
        this.processList = [];
      }
    },

    jumpProcessPage() {
      let p = parseInt(this.processPageInput);
      console.log('=== 处理流程跳转页面 ===');
      console.log('输入页码:', p);
      console.log('总页数:', this.processTotalPages);
      
      if (!isNaN(p) && p >= 1 && p <= this.processTotalPages) {
        this.processPage = p;
        this.processPageInput = p.toString();
        console.log('跳转到页码:', this.processPage);
        this.searchProcess();
      } else {
        alert('请输入有效的页码');
      }
    },
    closePointAdd() {
      this.pointAddMode = false;
    },
    savePointAdd() {
      // 调用后端接口创建点位信息
      this.createPointMessage();
    },
    async createPointMessage() {
      try {
        // 创建FormData对象，用于上传文件
        const formData = new FormData();
        formData.append('fac_id', this.pointAddItem.deviceNumber);
        formData.append('fac_name', this.pointAddItem.deviceName);
        formData.append('fac_model', this.pointAddItem.deviceType);
        formData.append('fac_state', this.pointAddItem.deviceStatus);
        formData.append('fac_point', this.pointAddItem.location);
        formData.append('detail_location', this.pointAddItem.detailLocation);
        formData.append('factory_area', this.pointAddItem.factory_area);
        formData.append('manufacturer', this.pointAddItem.manufacturer);
        formData.append('install_instruction', this.pointAddItem.installDesc);
        formData.append('install_date', this.pointAddItem.applyTime);
        formData.append('applicant', this.pointAddItem.reporter);

        // 如果有图片文件，添加到FormData
        if (this.pointAddItem.imageFile) {
          formData.append('install_photo', this.pointAddItem.imageFile);
        }

        const response = await createPointMessage(formData);
        const result = response.data;
        
        if (result.status === 'success') {
          // 创建成功，关闭弹窗并刷新数据
          this.pointAddMode = false;
          this.resetPointAddForm();
          this.fetchPointData(); // 刷新点位列表
          alert('点位信息创建成功！');
        } else {
          throw new Error(result.message || '创建失败');
        }
      } catch (error) {
        console.error('创建点位信息失败:', error);
        alert(`创建失败: ${error.message}`);
      }
    },
    resetPointAddForm() {
      this.pointAddItem = {
        deviceNumber: '',
        deviceName: '',
        deviceType: '摄像头',
        deviceStatus: '在线',
        location: '',
        detailLocation: '',
        installDesc: '',
        factory_area: '泰山路厂区',
        manufacturer: '海康威视',
        imageUrl: '',
        imageFile: null,
        reporter: '',
        applyTime: ''
      };
    },
    onPointAddImageChange(e) {
      const file = e.target.files[0];
      if (file) {
        // 保存文件对象用于上传
        this.pointAddItem.imageFile = file;
        
        // 预览图片
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.pointAddItem.imageUrl = ev.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    showPointView(item) {
      this.pointDetailItem = { ...item };
      this.pointDetailMode = 'view';
    },
    showPointEdit(item) {
      this.pointDetailItem = { ...item };
      this.pointDetailMode = 'edit';
    },
    closePointDetailModal() {
      this.pointDetailMode = '';
      this.pointDetailItem = null;
    },
    async savePointEdit() {
      try {
        // 创建FormData对象，用于上传文件
        const formData = new FormData();
        formData.append('fac_id', this.pointDetailItem.deviceNumber);
        formData.append('fac_name', this.pointDetailItem.deviceName);
        formData.append('fac_model', this.pointDetailItem.deviceType);
        formData.append('fac_state', this.pointDetailItem.status);
        formData.append('fac_point', this.pointDetailItem.location);
        formData.append('detail_location', this.pointDetailItem.detailLocation);
        formData.append('factory_area', this.pointDetailItem.factory_area);
        formData.append('manufacturer', this.pointDetailItem.manufacturer);
        formData.append('install_instruction', this.pointDetailItem.installInstruction);
        formData.append('install_date', this.pointDetailItem.installDate);
        formData.append('applicant', this.pointDetailItem.applicant);

        // 如果有图片文件，添加到FormData
        if (this.pointDetailItem.imageFile) {
          formData.append('install_photo', this.pointDetailItem.imageFile);
        }

        // 调用同一个接口保存编辑
        const response = await createPointMessage(formData);
        const result = response.data;
        
        if (result.status === 'success') {
          // 编辑成功，关闭弹窗并刷新数据
          this.pointDetailMode = '';
          this.pointDetailItem = null;
          this.fetchPointData(); // 刷新点位列表
          alert('点位信息编辑成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑点位信息失败:', error);
        alert(`编辑失败: ${error.message}`);
      }
    },
    showProcessView(item) {
      this.processDetailItem = { ...item };
      // 确保processState字段有值
      if (!this.processDetailItem.processState) {
        this.processDetailItem.processState = '未处理';
      }
      this.processDetailMode = 'view';
    },
    showProcessEdit(item) {
      this.processDetailItem = { ...item };
      // 确保processState字段有值
      if (!this.processDetailItem.processState) {
        this.processDetailItem.processState = '已解决';
      }
      // 确保process_instruction字段有值
      if (!this.processDetailItem.process_instruction) {
        this.processDetailItem.process_instruction = '';
      }
      // 如果处理时间为空，则设置为当前时间
      if (!this.processDetailItem.handleTime) {
        const now = new Date();
        // 格式化为 YYYY-MM-DDTHH:mm 格式，用于 datetime-local 输入框
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        this.processDetailItem.handleTime = `${year}-${month}-${day}T${hours}:${minutes}`;
      }
      this.processDetailMode = 'edit';
    },
    closeProcessDetailModal() {
      this.processDetailMode = '';
      this.processDetailItem = null;
    },
    async saveProcessEdit() {
      try {
        // 确保处理时间字段有值 - 检查空字符串和null/undefined
        if (!this.processDetailItem.handleTime || this.processDetailItem.handleTime.trim() === '') {
          const now = new Date();
          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, '0');
          const day = String(now.getDate()).padStart(2, '0');
          const hours = String(now.getHours()).padStart(2, '0');
          const minutes = String(now.getMinutes()).padStart(2, '0');
          this.processDetailItem.handleTime = `${year}-${month}-${day}T${hours}:${minutes}`;
        }

        // 格式化处理时间，确保后端能正确接收
        let formattedHandleTime = this.processDetailItem.handleTime;
        if (formattedHandleTime && formattedHandleTime.includes('T')) {
          // 如果包含T，说明是datetime-local格式，需要转换为后端期望的格式
          formattedHandleTime = formattedHandleTime.replace('T', ' ');
        }

        // 使用URLSearchParams构建请求数据
        const params = new URLSearchParams();
        params.append('violate_id', this.processDetailItem.violationNumber || '');
        params.append('fac_id', this.processDetailItem.originalData?.fac_id || '');
        params.append('fac_name', this.processDetailItem.deviceName || '');
        params.append('fac_type', this.processDetailItem.originalData?.fac_type || '');
        params.append('identify_type', this.processDetailItem.recognitionType || '');
        params.append('factory_area', this.processDetailItem.violationCompany || '');
        params.append('violator', this.processDetailItem.violationPerson || '');
        params.append('violate_date', this.processDetailItem.violationTime || '');
        params.append('violate_instruction', this.processDetailItem.originalData?.violate_instruction || '');
        // 修复字段映射：process_person 应该对应 handler 字段
        params.append('process_person', this.processDetailItem.handler || '');
        // 修复字段映射：process_date 应该对应 handleTime 字段
        params.append('process_date', formattedHandleTime || '');
        // 修复字段映射：process_state 应该对应 processState 字段
        params.append('process_state', this.processDetailItem.processState || '未处理');
        params.append('process_instruction', this.processDetailItem.process_instruction || '');

        // 详细打印请求信息
        console.log('=== 处理流程编辑接口调用调试信息 ===');
        console.log('当前编辑项:', this.processDetailItem);
        console.log('原始处理时间:', this.processDetailItem.handleTime);
        console.log('格式化后处理时间:', formattedHandleTime);
        console.log('处理人:', this.processDetailItem.handler);
        console.log('处理状态:', this.processDetailItem.processState);
        console.log('URLSearchParams内容:');
        for (let pair of params.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createViolation API');
        console.log('请求方法:', 'POST');
        console.log('========================');

        const response = await createViolation(params);
        
        // 详细打印响应信息
        console.log('=== 处理流程编辑接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');
        
        const result = response.data;
        
        if (result.status === 'success') {
          // 保存成功，关闭弹窗并刷新数据
          this.processDetailMode = '';
          this.processDetailItem = null;
          this.searchProcess(); // 刷新处理流程列表
          alert('处理流程信息保存成功！');
        } else if (result.status === 'repeat data') {
          alert('违规编号已存在，请检查后重试！');
        } else {
          throw new Error(result.message || '保存失败');
        }
      } catch (error) {
        console.error('保存处理流程信息失败:', error);
        alert(`保存失败: ${error.message}`);
      }
    },
      closeProcessAdd() {
        this.processAddMode = false;
        this.resetProcessAddForm();
      },
      openProcessAdd() {
        this.processAddMode = true;
        // 自动生成违规编号：当前时间格式为YYYYMMDDHHMMSS
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        
        this.processAddItem.violateId = `${year}${month}${day}${hours}${minutes}${seconds}`;
      },
      async saveProcessAdd() {
        try {
          // 验证必填字段
          if (!this.processAddItem.violateId) {
            alert('请输入违规编号');
            return;
          }
          if (!this.processAddItem.deviceName) {
            alert('请输入设备名称');
            return;
          }
          if (!this.processAddItem.recognitionType) {
            alert('请选择识别类型');
            return;
          }
          if (!this.processAddItem.factory_area) {
            alert('请选择所属厂区');
            return;
          }
          if (!this.processAddItem.violator) {
            alert('请输入违规人');
            return;
          }
          if (!this.processAddItem.violateDate) {
            alert('请选择违规时间');
            return;
          }

          // 使用URLSearchParams构建请求数据
          const params = new URLSearchParams();
          params.append('violate_id', this.processAddItem.violateId || '');
          params.append('fac_id', this.processAddItem.deviceName || ''); // 使用设备名称作为设备ID
          params.append('fac_name', this.processAddItem.deviceName || '');
          params.append('fac_type', this.processAddItem.deviceType || '');
          params.append('identify_type', this.processAddItem.recognitionType || '');
          params.append('factory_area', this.processAddItem.factory_area || '');
          params.append('violator', this.processAddItem.violator || '');
          params.append('violate_date', this.processAddItem.violateDate || '');
          params.append('violate_instruction', this.processAddItem.violateInstruction || '');
          params.append('process_person', this.processAddItem.processPerson || '');
          params.append('process_date', this.processAddItem.processDate || '');
          params.append('process_state', this.processAddItem.processState || '未处理');
          params.append('process_instruction', this.processAddItem.processInstruction || '');

          // 详细打印请求信息
          console.log('=== 处理流程新增接口调用调试信息 ===');
          console.log('当前新增项:', this.processAddItem);
          console.log('URLSearchParams内容:');
          for (let pair of params.entries()) {
            console.log(pair[0], pair[1]);
          }
          console.log('请求URL:', 'createViolation API');
          console.log('请求方法:', 'POST');
          console.log('========================');

          const response = await createViolation(params);
          
          // 详细打印响应信息
          console.log('=== 处理流程新增接口响应调试信息 ===');
          console.log('响应状态:', response.status);
          console.log('响应状态文本:', response.statusText);
          console.log('响应头:', response.headers);
          console.log('响应数据:', response.data);
          console.log('完整响应对象:', response);
          console.log('========================');
          
          const result = response.data;
          
          if (result.status === 'success') {
            // 创建成功，关闭弹窗并刷新数据
            this.processAddMode = false;
            this.resetProcessAddForm();
            this.searchProcess(); // 刷新处理流程列表
            alert('违规信息创建成功！');
          } else if (result.status === 'repeat data') {
            alert('违规编号已存在，请检查后重试！');
          } else {
            throw new Error(result.message || '创建失败');
          }
        } catch (error) {
          console.error('创建违规信息失败:', error);
          alert(`创建失败: ${error.message}`);
        }
      },
      resetProcessAddForm() {
        this.processAddItem = {
          violateId: '',
          deviceName: '',
          deviceType: '',
          recognitionType: '',
          factory_area: '',
          violator: '',
          violateDate: '',
          violateInstruction: '',
          processPerson: '',
          processDate: '',
          processState: '未处理',
          processInstruction: ''
        };
      },
      async showHistoryView(item) {
        this.historyDetailMode = 'view';
        
        // 如果还没有图片，则先加载图片
        if (item.imageData && !item.imageUrl) {
          try {
            console.log('开始加载历史记录图片:', item);
            
            // 新的数据格式中，图片URL直接存储在violation_photo字段中
            if (item.imageData.violation_photo) {
              // 转换图片URL格式并直接使用violation_photo作为图片URL
              item.imageUrl = this.convertImageUrl(item.imageData.violation_photo);
              console.log('历史记录图片加载成功，使用violation_photo:', item.imageUrl);
            } else {
              // 如果没有violation_photo，尝试使用旧的getCaptureImage方法
              const imageUrl = await this.getCaptureImage(
                item.imageData,
                item.originalCaptureTime || item.violationTime
              );
              if (imageUrl) {
                item.imageUrl = imageUrl;
                console.log('历史记录图片加载成功');
              } else {
                console.warn('历史记录图片加载失败');
              }
            }
          } catch (error) {
            console.error('加载历史记录图片失败:', error);
          }
        }
        
        // 图片加载完成后再设置historyDetailItem
        this.historyDetailItem = { ...item };
      },

      closeHistoryDetailModal() {
        this.historyDetailMode = '';
        this.historyDetailItem = null;
      },
    parseAIAlarmData(data) {
      // 这个方法现在用于单个接口的数据解析，返回解析后的数据数组
      try {
        console.log('开始解析AI智能检索数据，原始数据:', data);
        
        // 解析AI智能检索返回的JSON数据
        let searchResult;
        if (typeof data === 'string') {
          try {
            searchResult = JSON.parse(data);
            console.log('成功解析JSON字符串:', searchResult);
          } catch (parseError) {
            console.error('JSON解析失败:', parseError);
            console.error('原始字符串:', data);
            return [];
          }
        } else {
          searchResult = data;
          console.log('数据已经是对象格式:', searchResult);
        }

        // 检查数据结构
        console.log('检查数据结构:', {
          hasSearchResult: !!searchResult,
          hasSearchResultProperty: !!(searchResult && searchResult.SearchResult),
          hasAIAlarmInfo: !!(searchResult && searchResult.SearchResult && searchResult.SearchResult.AIAlarmInfo),
          searchResultKeys: searchResult ? Object.keys(searchResult) : [],
          searchResultStructure: searchResult && searchResult.SearchResult ? Object.keys(searchResult.SearchResult) : []
        });

        if (searchResult && searchResult.SearchResult && searchResult.SearchResult.AIAlarmInfo) {
          const aiAlarmList = searchResult.SearchResult.AIAlarmInfo;
          console.log('找到AIAlarmInfo数组，长度:', aiAlarmList.length);
          console.log('AIAlarmInfo第一条数据示例:', aiAlarmList[0]);
          
          const parsedData = [];
          
          // 将AI告警数据转换为历史查询格式
          aiAlarmList.forEach((item, index) => {
            console.log(`处理第${index + 1}条AI告警数据:`, item);
            
            const historyItem = {
              id: `ai_${Date.now()}_${index}`, // 使用时间戳确保ID唯一性
              deviceNumber: item.MPID || `MP_${index + 1}`,
              deviceName: item.MPName || '变电站设备',
              location: this.getLocationByChannel(item.channelID),
              violationType: this.getViolationTypeByChannel(item.channelID),
              violationPerson: '未知', // AI识别无法直接获取违规人信息
              violationTime: this.formatDateTime(item.dateTime),
              // 添加置信度字段
              confidence: item.confidence || 0,
              // 添加图片URL字段，优先使用AIOPDataUrl，其次使用url
              pictureUrl: item.url,
              // 保存原始AI数据用于详情展示
              aiData: {
                channelID: item.channelID,
                ruleID: item.ruleID,
                ruleName: item.ruleName,
                MPName: item.MPName,
                MPID: item.MPID,
                engine: item.engine,
                confidence: item.confidence,
                url: item.url,
                AIOPDataUrl: item.pictureUrl,
                eventType: item.eventType,
                taskID: item.taskID,
                taskType: item.taskType
              }
            };
            
            console.log(`转换后的历史记录项:`, historyItem);
            parsedData.push(historyItem);
          });
          
          console.log(`成功解析 ${parsedData.length} 条AI告警数据`);
          return parsedData;
          
        } else {
          console.error('AI智能检索数据格式不正确:', searchResult);
          console.error('期望的数据结构应该包含: SearchResult.AIAlarmInfo');
          
          // 尝试其他可能的数据结构
          if (searchResult && searchResult.AIAlarmInfo) {
            console.log('发现直接包含AIAlarmInfo的数据结构');
            return this.parseAIAlarmData({ SearchResult: { AIAlarmInfo: searchResult.AIAlarmInfo } });
          }
          
          // 如果还是没有找到，返回空数组
          console.error('无法找到AI告警数据，请检查数据结构');
          return [];
        }
      } catch (error) {
        console.error('解析AI智能检索数据失败:', error);
        console.error('错误详情:', error.stack);
        // 返回空数组，避免显示错误数据
        return [];
      }
    },

    // 新增方法：为不同接口解析数据
    parseAIAlarmDataForEndpoint(data, endpointIndex, endpointUrl) {
      // 调用原有的解析方法
      const parsedData = this.parseAIAlarmData(data);
      
      // 根据接口URL判断厂区来源
      let factory_area = '泰山路厂区'; // 默认值
      if (endpointUrl && endpointUrl.includes('10001')) {
        factory_area = '泰山路厂区';
      } else if (endpointUrl && endpointUrl.includes('10002')) {
        factory_area = '梅江道';
      }
      
      console.log(`解析接口数据: endpointIndex=${endpointIndex}, endpointUrl=${endpointUrl}, factory_area=${factory_area}`);
      
      // 为不同接口的数据添加标识，避免ID冲突
      parsedData.forEach((item, index) => {
        item.id = `endpoint_${endpointIndex}_${index}_${Date.now()}`;
        // 设置正确的厂区来源
        item.factory_area = factory_area;
        console.log(`设置数据项 ${index}: factory_area=${item.factory_area}`);
      });
      
      return parsedData;
    },
    
        getLocationByChannel(channelID) {
      // 根据通道ID映射安装位置
      const locationMap = {
        1: '低压工作区',
        2: '高压工作区',
      };
      return locationMap[channelID] || '未知位置';
    },
    
    getViolationTypeByChannel(channelID) {
      // 根据通道ID映射违规类型
      const violationTypeMap = {
        1: '未穿绝缘鞋',
        2: '未穿绝缘胶鞋',
      };
      return violationTypeMap[channelID] || 'AI识别违规';
    },
    
    formatDateTime(dateTimeStr) {
      try {
        if (!dateTimeStr) return '';
        // 解析ISO格式时间字符串
        const date = new Date(dateTimeStr);
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        });
      } catch (error) {
        console.error('时间格式化失败:', error);
        return dateTimeStr || '';
      }
    },

    setDefaultTimeRange() {
      // 如果用户没有设置时间，自动设置默认值
      if (!this.historyQuery.startDate) {
        const today = new Date(new Date() + 8 * 3600 * 1000);
        const todayStart = today.getFullYear() + "-01-01";
        this.historyQuery.startDate = todayStart; // 只取日期部分
        this.processQuery.startDate = todayStart
        this.repairQuery.startDate = todayStart
      }
      if (!this.historyQuery.endDate) {
        const today = new Date(new Date() + 8 * 3600 * 1000);
        const todayEnd = today;
        this.historyQuery.endDate = todayEnd.toISOString().slice(0, 10); // 只取日期部分
        this.processQuery.endDate = this.historyQuery.endDate
        this.repairQuery.endDate = this.historyQuery.endDate
      }

    },

    
    loadHistoryImage(item) {
      if (item.imageUrl) {
        this.previewImage(item.imageUrl);
      } else {
        console.warn('图片URL为空，无法加载图片');
      }
    },
    testAISearch() {
      // 模拟测试AI智能检索
      console.log('点击测试AI搜索按钮');
      this.historyQuery.startDate = '2023-01-01'; // 设置一个较早的时间，只包含日期
      this.historyQuery.endDate = '2023-12-31'; // 设置一个较晚的时间，只包含日期
      this.searchHistory(); // 调用搜索方法
    },
    
    // 测试数据解析方法
    handleImageError() {
      // 图片加载失败时的处理
      console.warn('图片加载失败:', this.currentImage);
      this.currentImage = '';
    },
    
    // 生成当前时间字符串，格式：YYYYMMDDHHMMSS
    getCurrentTimeString() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    },
    
    // 格式化时间，去掉毫秒部分
    formatTime(timeStr) {
      if (!timeStr) return '';
      try {
        // 如果包含毫秒，去掉毫秒部分
        if (timeStr.includes('.')) {
          return timeStr.split('.')[0];
        }
        return timeStr;
      } catch (error) {
        console.error('时间格式化失败:', error);
        return timeStr || '';
      }
    },

    formatDateForAPI(dateTimeString) {
      if (!dateTimeString) return '';
      try {
        let date;
        
        // 如果已经是ISO格式，直接使用
        if (dateTimeString.includes('T') || dateTimeString.includes('-')) {
          date = new Date(dateTimeString);
        } else {
          // 如果是其他格式，尝试解析
          date = new Date(dateTimeString);
        }
        
        if (isNaN(date.getTime())) {
          console.warn('日期解析失败:', dateTimeString);
          return '';
        }
        
        // 格式化为 YYYY-MM-DD HH:mm:ss 格式
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (error) {
        console.error('日期格式化失败:', error);
        return '';
      }
    },

    // 设备维修相关方法
    async searchRepair() {
      try {
        // 构建查询参数
        const params = {};
        if (this.repairQuery.facMessage) params.fac_message = this.repairQuery.facMessage;
        if (this.repairQuery.resolutionState) params.resolution_state = this.repairQuery.resolutionState;
        if (this.repairQuery.startDate) params.start_date = this.repairQuery.startDate;
        if (this.repairQuery.endDate) params.end_date = this.repairQuery.endDate;
        params.page_number = this.repairPage;
        params.per_page = this.repairPageSize;

        console.log('=== 设备维修查询请求参数 ===');
        console.log('请求参数:', params);
        console.log('当前页码:', this.repairPage);
        console.log('每页数量:', this.repairPageSize);
        console.log('========================');

        const response = await queryMaintenance(params);
        
        console.log('=== 设备维修接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应数据:', response.data);
        console.log('当前页:', response.data.current_page);
        console.log('总页数:', response.data.total_pages);
        console.log('总数据量:', response.data.total);
        console.log('========================');

        // 检查响应数据结构
        if (response.data && Array.isArray(response.data.data)) {
          // 转换API返回的数据格式为前端需要的格式
          this.repairList = response.data.data.map(item => {
            console.log('处理维修数据项:', item);

            // 处理null值，提供默认值
            const processedItem = {
              id: item.maintenance_id || item.id || '未知ID',
              maintenance_id: item.maintenance_id || item.id || '未知ID',
              fac_id: item.fac_id || '未知设备',
              fac_name: item.fac_name || '未知设备名称',
              fac_point: item.fac_point || '未知位置',
              applicant: item.applicant || '未知申报人',
              applicant_date: item.applicant_date || '',
              fault_description: item.fault_description || '无故障描述',
              resolution_state: item.resolution_state || '未解决',
              resolution_description: item.resolution_description || '无解决说明',
              resolution_people: item.resolution_people || '未知解决人',
              resolution_date: item.resolution_date || '',
              // 添加图片URL处理
              faultImage: this.processImageUrl(item.fault_photo_url) || null,
              solveImage: this.processImageUrl(item.resolution_photo_url) || null
            };

            console.log('处理后的维修数据项:', processedItem);
            return processedItem;
          });

          console.log('=== 设备维修数据转换完成 ===');
          console.log('转换后的数据:', this.repairList);
          console.log('数据长度:', this.repairList.length);
          console.log('========================');

          // 更新分页信息
          this.repairTotalPages = response.data.total_pages || 1;
          this.repairPage = response.data.current_page || 1;
          
          // 设置总页数状态
          this.repairTotalPagesState = response.data.total_pages || 1;

          // 强制触发Vue的响应式更新
          this.$forceUpdate();
          
          // 使用nextTick确保DOM更新完成
          this.$nextTick(() => {
            console.log('=== nextTick后的设备维修状态检查 ===');
            console.log('this.repairList:', this.repairList);
            console.log('this.pagedRepairList:', this.pagedRepairList);
            console.log('this.repairPage:', this.repairPage);
            console.log('this.repairTotalPages:', this.repairTotalPages);
            console.log('========================');
          });

        } else {
          console.error('查询设备维修失败: 响应数据格式不正确');
          console.log('响应数据结构:', response.data);
          this.repairList = [];
        }
      } catch (error) {
        console.error('查询设备维修失败:', error);
        this.repairList = [];
      }
    },



    jumpRepairPage() {
      let p = parseInt(this.repairPageInput);
      console.log('=== 设备维修跳转页面 ===');
      console.log('输入页码:', p);
      console.log('总页数:', this.repairTotalPages);
      
      if (!isNaN(p) && p >= 1 && p <= this.repairTotalPages) {
        this.repairPage = p;
        this.repairPageInput = p.toString();
        console.log('跳转到页码:', this.repairPage);
        this.searchRepair();
      } else {
        alert('请输入有效的页码');
      }
    },

    generateMaintenanceId() {
      // 生成维修ID：当前时间格式为YYYYMMDDHHMMSS
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      
      return `${year}${month}${day}${hours}${minutes}${seconds}`;
    },

    closeRepairAdd() {
      this.repairAddMode = false;
      this.resetRepairAddForm();
    },

    openRepairAdd() {
      this.repairAddMode = true;
      // 设置申报时间为当前时间
      const now = new Date();
      this.repairAddItem.applicant_date = now.toISOString().slice(0, 16);
      // 解决时间默认为空，让用户手动填写
      this.repairAddItem.resolution_date = '';
      // 获取点位数据
      this.fetchPointOptions();
    },

    resetRepairAddForm() {
      this.repairAddItem = {
        maintenance_id: '',
        fac_id: '',
        fac_name: '',
        fac_point: '',
        applicant: '',
        applicant_date: '',
        fault_description: '',
        resolution_state: '未解决',
        resolution_description: '',
        resolution_people: '',
        resolution_date: '',
        // 新增图片字段重置
        faultImage: null,
        solveImage: null
      };
    },

    async saveRepairAdd() {
      try {
        // 验证必填字段
        if (!this.repairAddItem.fac_id || !this.repairAddItem.fac_name || !this.repairAddItem.applicant) {
          alert('请填写设备编号、设备名称和申报人信息');
          return;
        }

        // 使用FormData构建请求数据（支持文件上传）
        const formData = new FormData();
        formData.append('maintenance_id', this.generateMaintenanceId());
        formData.append('fac_id', this.repairAddItem.fac_id);
        formData.append('fac_name', this.repairAddItem.fac_name);
        formData.append('fac_point', this.repairAddItem.fac_point);
        formData.append('applicant', this.repairAddItem.applicant);
        formData.append('applicant_date', this.repairAddItem.applicant_date || new Date().toISOString().slice(0, 16));
        formData.append('fault_description', this.repairAddItem.fault_description || '');
        formData.append('resolution_state', this.repairAddItem.resolution_state || '未解决');
        formData.append('resolution_description', this.repairAddItem.resolution_description || '');
        formData.append('resolution_people', this.repairAddItem.resolution_people || '');
        formData.append('resolution_date', this.repairAddItem.resolution_date || '');

        // 添加图片数据
        if (this.repairAddItem.faultImage) {
          // 将base64转换为Blob
          const faultBlob = this.dataURLtoBlob(this.repairAddItem.faultImage);
          if (faultBlob) {
            formData.append('fault_photo', faultBlob, 'fault_photo.jpg');
          } else {
            console.warn('faultImage 转换失败，跳过此图片');
          }
        }

        if (this.repairAddItem.solveImage) {
          // 将base64转换为Blob
          const solveBlob = this.dataURLtoBlob(this.repairAddItem.solveImage);
          if (solveBlob) {
            formData.append('resolution_photo', solveBlob, 'resolution_photo.jpg');
          } else {
            console.warn('solveImage 转换失败，跳过此图片');
          }
        }

        // 详细打印请求信息
        console.log('=== 设备维修新增接口调用调试信息 ===');
        console.log('当前新增项:', this.repairAddItem);
        console.log('FormData内容:');
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createMaintenance API');
        console.log('请求方法:', 'POST');
        console.log('========================');

        const response = await createMaintenance(formData);

        // 详细打印响应信息
        console.log('=== 设备维修新增接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');

        if (response.data.status === 'success') {
          alert('新增成功');
          this.repairAddMode = false;
          this.searchRepair(); // 重新加载列表
        } else {
          alert('新增失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('=== 设备维修新增接口调用失败 ===');
        console.error('错误详情:', error);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('========================');
        alert('新增失败，请查看控制台');
      }
    },

    showRepairView(item) {
      this.repairDetailItem = { ...item };
      this.repairDetailMode = 'view';
    },

    showRepairEdit(item) {
      this.repairDetailItem = { ...item };
      this.repairDetailMode = 'edit';
    },

    closeRepairDetailModal() {
      this.repairDetailMode = '';
      this.repairDetailItem = null;
    },

    async saveRepairEdit() {
      try {
        // 验证必填字段
        if (!this.repairDetailItem.fac_id || !this.repairDetailItem.fac_name) {
          alert('请填写设备编号和设备名称信息');
          return;
        }

        // 使用FormData构建请求数据（支持文件上传）
        const formData = new FormData();
        formData.append('maintenance_id', this.repairDetailItem.maintenance_id);
        formData.append('fac_id', this.repairDetailItem.fac_id);
        formData.append('fac_name', this.repairDetailItem.fac_name);
        formData.append('fac_point', this.repairDetailItem.fac_point);
        formData.append('applicant', this.repairDetailItem.applicant || '');
        formData.append('applicant_date', this.repairDetailItem.applicant_date || '');
        formData.append('fault_description', this.repairDetailItem.fault_description || '');
        formData.append('resolution_state', this.repairDetailItem.resolution_state || '未解决');
        formData.append('resolution_description', this.repairDetailItem.resolution_description || '');
        formData.append('resolution_people', this.repairDetailItem.resolution_people || '');
        formData.append('resolution_date', this.repairDetailItem.resolution_date || '');

        // 添加图片数据
        if (this.repairDetailItem.faultImage) {
          // 将base64转换为Blob
          const faultBlob = this.dataURLtoBlob(this.repairDetailItem.faultImage);
          if (faultBlob) {
            formData.append('fault_photo', faultBlob, 'fault_photo.jpg');
          } else {
            console.warn('faultImage 转换失败，跳过此图片');
          }
        }

        if (this.repairDetailItem.solveImage) {
          // 将base64转换为Blob
          const solveBlob = this.dataURLtoBlob(this.repairDetailItem.solveImage);
          if (solveBlob) {
            formData.append('resolution_photo', solveBlob, 'resolution_photo.jpg');
          } else {
            console.warn('solveImage 转换失败，跳过此图片');
          }
        }

        // 详细打印请求信息
        console.log('=== 设备维修编辑接口调用调试信息 ===');
        console.log('当前编辑项:', this.repairDetailItem);
        console.log('FormData内容:');
        for (let pair of formData.entries()) {
          console.log(pair[0], pair[1]);
        }
        console.log('请求URL:', 'createMaintenance API');
        console.log('请求方法:', 'POST');
        console.log('========================');

        const response = await createMaintenance(formData);

        // 详细打印响应信息
        console.log('=== 设备维修编辑接口响应调试信息 ===');
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应头:', response.headers);
        console.log('响应数据:', response.data);
        console.log('完整响应对象:', response);
        console.log('========================');

        if (response.data.status === 'success') {
          alert('保存成功');
          this.closeRepairDetailModal();
          this.searchRepair(); // 重新加载列表
        } else {
          alert('保存失败: ' + (response.data.message || '未知错误'));
        }
      } catch (error) {
        console.error('=== 设备维修编辑接口调用失败 ===');
        console.error('错误详情:', error);
        console.error('错误消息:', error.message);
        console.error('错误堆栈:', error.stack);
        console.error('========================');
        alert('保存失败，请查看控制台');
      }
    },
    changeHistoryPage(page) {
      console.log('=== 历史查询分页切换 ===');
      console.log('当前页:', this.historyPage);
      console.log('目标页:', page);
      console.log('总页数:', this.historyTotalPages);
      
      if (page < 1) {
        console.warn('页码不能小于1，忽略分页切换');
        return;
      }
      
      this.historyPage = page;
      console.log('设置新页码:', this.historyPage);
      
      // 重新查询数据
      this.searchHistory();
    },
    // 新增：通过中间件获取抓拍图片的方法
    async getCaptureImage(imageData, captureTime) {
      if (!imageData || !captureTime) {
        console.warn('缺少图片数据或抓拍时间');
        return null;
      }

      try {
        console.log('=== 开始获取抓拍图片 ===');
        console.log('图片数据:', imageData);
        console.log('抓拍时间:', captureTime);

        // 新的数据格式中，图片URL直接存储在violation_photo字段中
        if (imageData.violation_photo) {
          // 直接使用violation_photo作为图片URL
          console.log('使用violation_photo作为图片URL:', imageData.violation_photo);
          return imageData.violation_photo;
        }

        // 如果没有violation_photo，尝试使用中间件获取图片
        // 第一步：查询图片信息，获取fileName
        const picRecInfoXml = `<?xml version="1.0" encoding="utf-8"?>
<PicRecInfoSearchDescription>
  <targetEndpoint>/ISAPI/Traffic/ContentMgmt/picRecInfo</targetEndpoint>
  <searchID>CB5062A2-B830-0001-D958-B1D71C28DDE0</searchID>
  <VehicleList>
    <Vehicle>
      <vehicleID>CB5062A2-B830-0001-4E47-1C3018347BE0</vehicleID>
      <channel>${imageData.channel || '0'}</channel>
      <ctrl>${imageData.ctrl || '0'}</ctrl>
      <drive>${imageData.drive || '0'}</drive>
      <part>${imageData.part || '0'}</part>
      <fileNo>${imageData.fileNo || ''}</fileNo>
      <startOffset>${imageData.startOffset || ''}</startOffset>
      <picLen>${imageData.picLen || ''}</picLen>
      <captureTime>${captureTime}</captureTime>
      <violationType/>
    </Vehicle>
  </VehicleList>
</PicRecInfoSearchDescription>`;

        console.log('查询图片信息XML:', picRecInfoXml);

        // 通过中间件查询图片信息
        const picRecInfoResponse = await fetch('http://47.93.132.27:10000/api/device/request', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/xml',
          },
          body: picRecInfoXml
        });

        if (!picRecInfoResponse.ok) {
          throw new Error(`查询图片信息失败: ${picRecInfoResponse.status}`);
        }

        const picRecInfoText = await picRecInfoResponse.text();
        console.log('图片信息查询响应:', picRecInfoText);

        // 解析响应获取fileName
        let fileName = null;
        try {
          // 尝试解析JSON响应
          const jsonResponse = JSON.parse(picRecInfoText);
          if (jsonResponse.success && jsonResponse.data) {
            // 解析XML数据获取第二个fileName
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(jsonResponse.data, 'text/xml');
            const fileNameElements = xmlDoc.querySelectorAll('fileName');
            if (fileNameElements && fileNameElements.length >= 2) {
              // 获取第二个fileName字段
              fileName = fileNameElements[1].textContent;
              console.log('获取到第二个fileName:', fileName);
            } else if (fileNameElements && fileNameElements.length === 1) {
              // 如果只有一个fileName，使用第一个
              fileName = fileNameElements[0].textContent;
              console.log('只有一个fileName，使用第一个:', fileName);
            }
          }
        } catch (jsonError) {
          // 如果不是JSON，尝试直接解析XML
          try {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(picRecInfoText, 'text/xml');
            const fileNameElements = xmlDoc.querySelectorAll('fileName');
            if (fileNameElements && fileNameElements.length >= 2) {
              // 获取第二个fileName字段
              fileName = fileNameElements[1].textContent;
              console.log('获取到第二个fileName:', fileName);
            } else if (fileNameElements && fileNameElements.length === 1) {
              // 如果只有一个fileName，使用第一个
              fileName = fileNameElements[0].textContent;
              console.log('只有一个fileName，使用第一个:', fileName);
            }
          } catch (xmlError) {
            console.error('解析XML响应失败:', xmlError);
          }
        }

        if (!fileName) {
          console.warn('未能获取到fileName');
          return null;
        }
        
        console.log('获取到fileName:', fileName);

        // 第二步：通过fileName获取图片
        console.log('准备调用图片接口，fileName:', fileName);
        
        // 直接调用中间件的图片接口
        try {
          const pictureUrl = `http://47.93.132.27:10000/api/device/picture/${encodeURIComponent(fileName)}`;
          console.log('图片接口URL:', pictureUrl);
          
          const pictureResponse = await fetch(pictureUrl, {
            method: 'GET',
            headers: {
              'Accept': 'image/*',
            }
          });
          
          console.log("pictureResponse:", pictureResponse);
          console.log("响应状态:", pictureResponse.status, pictureResponse.statusText);
          
          if (!pictureResponse.ok) {
            throw new Error(`获取图片失败: ${pictureResponse.status}`);
          }
          
          const pictureData = await pictureResponse.blob();
          console.log('获取到图片数据:', pictureData);
          console.log('图片大小:', pictureData.size, 'bytes');
          console.log('图片类型:', pictureData.type);
          
          // 创建图片URL用于显示
          const imageUrl = URL.createObjectURL(pictureData);
          console.log('创建的图片URL:', imageUrl);
          
          return imageUrl;
          
        } catch (pictureError) {
          console.error('获取图片失败:', pictureError);
          return null;
        }

             } catch (error) {
         console.error('获取抓拍图片失败:', error);
         return null;
       }
     },
    // 新增：刷新当前标签页数据的方法
    refreshCurrentTab() {
      console.log('刷新当前标签页:', this.activeTab);
      
      switch (this.activeTab) {
        case '实时告警':
          this.searchAlarm();
          break;
        case '历史查询':
          this.searchHistory();
          break;
        case '点位管理':
          this.searchPoint();
          break;
        case '处理流程':
          this.searchProcess();
          break;
        case '设备维修':
          this.searchRepair();
          break;
        default:
          console.warn('未知的标签页:', this.activeTab);
      }
    },

    // 新增：监听标签页切换的方法
    switchTab(tabName) {
      this.activeTab = tabName;
      
      // 根据不同的标签页执行相应的初始化操作
      this.$nextTick(() => {
        switch (tabName) {
          case '实时告警':
            // 实时告警页面使用独立的数据源
            this.searchAlarm();
            break;
          case '历史查询':
            // 历史查询页面使用独立的数据源
            this.searchHistory();
            break;
          case '点位管理':
            // 点位管理页面需要自动加载数据
            console.log('切换到点位管理，自动加载数据');
            this.searchPoint();
            break;
          case '处理流程':
            // 处理流程页面重新查询数据，但保持当前页码
            this.searchProcess();
            break;
          case '设备维修':
            // 设备维修页面已经在mounted中初始化，这里可以重新查询
            this.searchRepair();
            break;
        }
      });
    },
    changePointPage(page) {
      console.log('=== 点位管理分页切换 ===');
      console.log('当前页:', this.pointPage);
      console.log('目标页:', page);
      console.log('总页数:', this.pointTotalPages);
      
      if (page < 1 || page > this.pointTotalPages) {
        console.warn('页码超出范围，忽略分页切换');
        return;
      }
      
      this.pointPage = page;
      this.pointPageInput = page.toString();
      console.log('设置新页码:', this.pointPage);
      
      // 重新查询数据
      this.searchPoint();
    },
    changeProcessPage(page) {
      console.log('=== 处理流程分页切换 ===');
      console.log('当前页:', this.processPage);
      console.log('目标页:', page);
      console.log('总页数:', this.processTotalPages);
      
      if (page < 1 || page > this.processTotalPages) {
        console.warn('页码超出范围，忽略分页切换');
        return;
      }
      
      this.processPage = page;
      this.processPageInput = page.toString();
      console.log('设置新页码:', this.processPage);
      
      // 重新查询数据
      this.searchProcess();
    },
    changeRepairPage(page) {
      console.log('=== 设备维修分页切换 ===');
      console.log('当前页:', this.repairPage);
      console.log('目标页:', page);
      console.log('总页数:', this.repairTotalPages);
      
      if (page < 1 || page > this.repairTotalPages) {
        console.warn('页码超出范围，忽略分页切换');
        return;
      }
      
      this.repairPage = page;
      this.repairPageInput = page.toString();
      console.log('设置新页码:', this.repairPage);
      
      // 重新查询数据
      this.searchRepair();
    },
    // 添加获取点位选项的方法
    async fetchPointOptions() {
      try {
        const params = {
          page: 1,
          per_page: 1000 // 获取所有点位数据
        };
        
        const response = await queryPointMessage(params);
        const result = response.data;
        
        if (result.status === 'success' || result.data) {
          this.pointOptions = result.data.map(item => ({
            fac_id: item.fac_id,
            fac_name: item.fac_name,
            fac_point: item.fac_point,
            factory_area: item.factory_area
          }));
          console.log('获取点位选项成功:', this.pointOptions);
        } else {
          console.error('获取点位选项失败:', result);
          this.pointOptions = [];
        }
      } catch (error) {
        console.error('获取点位数据失败:', error);
        this.pointOptions = [];
      }
    },
    // 添加设备选择变化时的处理方法
    onDeviceChange() {
      // 当设备编号改变时，自动填充设备名称和设备点位
      const selectedDevice = this.pointOptions.find(option => option.fac_id === this.repairAddItem.fac_id);
      if (selectedDevice) {
        this.repairAddItem.fac_name = selectedDevice.fac_name;
        this.repairAddItem.fac_point = selectedDevice.fac_point;
      } else {
        this.repairAddItem.fac_name = '';
        this.repairAddItem.fac_point = '';
      }
    },


    // 图片预览方法
    previewImage(url) {
      this.previewImageUrl = url;
      this.showImagePreview = true;
    },
    closeImagePreview() {
      this.showImagePreview = false;
      this.previewImageUrl = '';
    },

    // 新增弹窗图片上传方法
    onRepairAddImageChange(e, type) {
      console.log('=== 图片上传开始 ===');
      console.log('事件对象:', e);
      console.log('类型:', type);
      console.log('文件列表:', e.target.files);
      
      const file = e.target.files[0];
      if (file) {
        console.log('选择的文件:', file);
        console.log('文件大小:', file.size, 'bytes');
        console.log('文件类型:', file.type);
        
        const reader = new FileReader();
        reader.onload = (ev) => {
          console.log('文件读取完成');
          console.log('读取结果类型:', typeof ev.target.result);
          console.log('读取结果长度:', ev.target.result.length);
          
          if (type === 'fault') {
            this.repairAddItem.faultImage = ev.target.result;
            console.log('故障图片已设置，长度:', this.repairAddItem.faultImage.length);
          } else {
            this.repairAddItem.solveImage = ev.target.result;
            console.log('解决图片已设置，长度:', this.repairAddItem.solveImage.length);
          }
          
          // 强制更新视图
          this.$forceUpdate();
          console.log('=== 图片上传完成 ===');
        };
        
        reader.onerror = (error) => {
          console.error('文件读取失败:', error);
        };
        
        reader.readAsDataURL(file);
      } else {
        console.warn('没有选择文件');
      }
    },

    // 编辑弹窗图片上传方法
    onRepairDetailImageChange(e, type) {
      console.log('=== 编辑弹窗图片上传开始 ===');
      console.log('事件对象:', e);
      console.log('类型:', type);
      console.log('文件列表:', e.target.files);
      
      const file = e.target.files[0];
      if (file) {
        console.log('选择的文件:', file);
        console.log('文件大小:', file.size, 'bytes');
        console.log('文件类型:', file.type);
        
        const reader = new FileReader();
        reader.onload = (ev) => {
          console.log('文件读取完成');
          console.log('读取结果类型:', typeof ev.target.result);
          console.log('读取结果长度:', ev.target.result.length);
          
          if (type === 'fault') {
            this.repairDetailItem.faultImage = ev.target.result;
            console.log('故障图片已设置，长度:', this.repairDetailItem.faultImage.length);
          } else {
            this.repairDetailItem.solveImage = ev.target.result;
            console.log('解决图片已设置，长度:', this.repairDetailItem.solveImage.length);
          }
          
          // 强制更新视图
          this.$forceUpdate();
          console.log('=== 编辑弹窗图片上传完成 ===');
        };
        
        reader.onerror = (error) => {
          console.error('文件读取失败:', error);
        };
        
        reader.readAsDataURL(file);
      } else {
        console.warn('没有选择文件');
      }
    },

    // 将base64图片转换为Blob
    dataURLtoBlob(dataURL) {
      if (!dataURL) {
        console.warn('dataURLtoBlob: dataURL为空');
        return null;
      }
      
      // 检查dataURL格式
      const arr = dataURL.split(',');
      if (arr.length !== 2) {
        console.error('dataURLtoBlob: 无效的dataURL格式', dataURL);
        return null;
      }
      
      // 安全地提取MIME类型
      const mimeMatch = arr[0].match(/:(.*?);/);
      if (!mimeMatch) {
        console.error('dataURLtoBlob: 无法提取MIME类型', arr[0]);
        return null;
      }
      
      const mime = mimeMatch[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },

    // 处理图片URL，添加API前缀
    processImageUrl(url) {
      if (!url) return url;
      const matches = url.match('/media.*')
      console.log(matches[0])
      let result = null
      if(matches.length > 0) result = 'https://gdykpt.cn' + matches[0]
      console.log(result)
      return result;
    },
    // 添加图片上传处理方法
    onPointDetailImageChange(e) {
  const file = e.target.files[0];
  if (file) {
    // 保存文件对象用于上传
    this.pointDetailItem.imageFile = file;
    
    // 预览图片
    const reader = new FileReader();
    reader.onload = (ev) => {
      this.pointDetailItem.installPhotoUrl = ev.target.result;
    };
    reader.readAsDataURL(file);
  }
},
  },

  mounted() {
    // 设置默认时间范围
    this.setDefaultTimeRange();
    
    // 初始化实时告警分页状态
    this.alarmPage = 1;
    this.alarmPageInput = '1';
    
    // 设置默认申请时间为当前时间
    const now = new Date();
    this.pointAddItem.applyTime = now.toISOString().slice(0, 16);
    
    // 设置默认违规时间和处理时间为当前时间
    this.processAddItem.violateDate = now.toISOString().slice(0, 16);
    this.processAddItem.processDate = now.toISOString().slice(0, 16);
    this.processAddItem.processState = '未处理';
    
    // 设置默认申报时间和解决时间为当前时间
    this.repairAddItem.applicant_date = now.toISOString().slice(0, 16);
    this.repairAddItem.resolution_date = now.toISOString().slice(0, 16);
    
    // 初始化处理流程数据（不重置页码）
    this.searchProcess();
    
    // 初始化实时告警数据（使用独立的数据源）
    this.searchAlarm();
    
    // 初始化历史查询数据（使用独立的数据源）
    this.searchHistory();
    
    // 初始化设备维修数据
    this.searchRepair();
  }
}
</script>


<style scoped>
/* 图片展示区样式 */
.image-preview {
  width: 500px;
  height: 500px;
  background-color: #000;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.preview-header {
  padding: 16px;
  background-color: #1a1a1a;
  color: #fff;
  flex-shrink: 0;
}

.preview-title {
  font-size: 16px;
  font-weight: 500;
  margin-right: 12px;
}

.preview-subtitle {
  font-size: 14px;
  color: #999;
}

.preview-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.preview-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.no-image {
  color: #999;
  font-size: 14px;
  text-align: center;
}

/* 数据布局 */
.data-layout {
  display: flex;
  gap: 24px;
}

/* 告警列表样式 */
.alarm-list {
  flex: 1;
}

.list-title {
  font-size: 16px;
  color: #333;
  margin: 0 0 16px 0;
}

/* 表格样式 */
.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 12px 16px;
  text-align: left;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.data-table th {
  background-color: #f5f6fa;
  color: #666;
  font-weight: 500;
}

.data-table tr {
  cursor: pointer;
  transition: background-color 0.3s;
}

.data-table tr:hover {
  background-color: #f5f6fa;
}

.data-table tr.active {
  background-color: #e6e9f0;
}

/* 分页样式 */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 24px;
}

.page-btn {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background: #fff;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.3s;
}

.page-btn:hover:not(:disabled) {
  background: #f5f6fa;
  border-color: #ccc;
}

.page-btn.active {
  background: #1976d2;
  color: #fff;
  border-color: #1976d2;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-jump {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 16px;
}

.jump-btn {
  padding: 6px 12px;
  border: 1px solid #ddd;
  background: #fff;
  color: #666;
  cursor: pointer;
  border-radius: 4px;
  font-size: 12px;
}

.jump-btn:hover {
  background: #f5f6fa;
  border-color: #ccc;
}
</style>
